import _ from "lodash";
import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import classes from "./SubjectJournalCard.scss";
import MultipleAttachmentsSlider from "Post/components/MultipleAttachmentsSlider";
import SingleUserProfile from "Post/components/SingleUserProfile";
import {
  getDateAndTimeSince,
  isSafari,
  onEnterOrSpaceKeyDown,
  getGlobalTimezone,
} from "Utils";
import ACLStore from "lib/aclStore";
import DropDown from "../FooterButtons/DropDown";
import I18nHOC from "UIComponents/I18nHOC";
import TextMoreLessV2 from "UIComponents/TextMoreLessV2";
import UIModal from "UIComponents/UIModal";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import AudioWaveformPlayer from "UIComponents/AudioWaveformPlayer";
import MediaModal from "UIComponents/MediaModal";
import TheatreModeV2 from "UIComponents/TheatreModeV2";
import SharedAvatarListPopover from "UnitPlans/components/SharedAvatarListPopover";
import withQueryParamsBasedInterface from "UIComponents/QueryParamsBasedInterfaceHOC";
import { compose, graphql } from "lib/apolloClient";
import { connect } from "react-redux";
import TaggedFolders from "Post/components/TaggedFolders";
import PostSharedWithModal from "AppComponents/Post/components/PostSharedWithModal";
import {
  Button,
  DatePicker,
  IconButton,
  Tag,
  TimePicker,
  Tooltip,
  AvatarGroup,
  Avatar,
  Modal,
  useDSContext,
} from "@toddle-edu/ds-web";
import {
  CloseOutlined,
  CommentCircleRightOutlined,
  PublishOutlined,
  PencilOutlined,
  CommentRemarkOutlined,
  WarningTriangleFilled,
  ClockFilled,
  DownloadOutlined,
} from "@toddle-edu/ds-icons";
import {
  hasTranslationPermission,
  getPostTranslationFilter,
  isPortfolioParityEnabled,
  fetchStudentActivitiesMemoized,
  fetchfilteredStudentActivities,
  isPortfolioParityEnabledAndIsJournalRoute,
  isPortfolioReviewSetupEnabled,
  isPortfolioReviewSetupEnabledAndIsReviewRoute,
  isPortfolioReviewSetupEnabledAndIsJournalRoute,
  isPortfolioFilterRevamp,
  isPortfolioRevampAndIsJournalRoute,
  getIsNewGoalTaggingEnabled,
  getTaggedAssessment,
  isAssessmentTagged,
  showAcademicYearFilterProfilePortfolio,
  isNewNotesUi,
  getIsEnableFamilyConsolidatedPortfolio,
} from "Post/utils";
import { useKeyDownWrapper } from "Post/hooks";
import { colors } from "Constants";
import StudentResponseV2 from "AppComponents/Post/routes/CreatePost/components/Screens/StudentResponseV2";
import { Trans } from "react-i18next";
import { getPostTranslationQuery } from "Post/modules/PostQuery";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import {
  goToRelativeRoute,
  downloadFromUrl,
  removeProgressElement,
} from "modules/Services";
import { TAGGABLE_PROJECT_ELEMENTS } from "routes/routes/Teacher/routes/Projects/routes/ProjectDetails/routes/ProcessJournal/modules/Module";
import {
  TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP,
  TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP,
  TEMPLATE_FIELD_SL_LEARNING_OUTCOMES_DP,
  TEMPLATE_FIELD_CE_LEARNING_OUTCOMES_DP,
  TEMPLATE_FIELD_CE_PROCESS_STAGES,
  TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS,
  TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES,
  TABLET_LANDSCAPE_MEDIA_QUERY,
} from "Constants/stringConstants";
import { getIsTypeOfProjectPortfolioLOs } from "Projects/modules/Utils";
import moment from "moment";
import {
  updatePostDate,
  markPostAsSeenByUser,
  addPostAsSeen,
  updatePostStatus,
} from "Journal/modules/JournalModule";
import { getSettingValue } from "modules/PermissionModule";
import classNames from "classnames";
import { getCourseDetailsFromCache } from "Teacher/routes/Courses/routes/Course/modules/CourseGraphqlHelpers";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import SchedulePostModal from "AppComponents/Post/components/SchedulePostModal";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import CardCommentsV2 from "AppComponents/Post/components/CardComments/CardCommentsV2";
import { PostCommentFragment } from "Post/modules/PostFragments";
import { syncPostCommentsCache } from "Post/modules/PostGraphqlHelpers";
import {
  getSelectedCurriculumId,
  getSelectedAcademicYearId,
  getDefaultStudentNameOrderPreference,
  getDefaultStudentIdentifierNamePreference,
} from "modules/CommonSelectors";

import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";

import { hasIncludeGivenPathInCurrentRoute } from "Teacher/routes/Courses/routes/Course/routes/UnitPlans/routes/UnitPlanDetails/routes/EditUnitPlan/routes/IBPlanner/modules/IBPlannerModule";
import FooterText from "../FooterText";
import PostSeenLikeModal from "../PostSeenLikeModal";
import { FooterButtons } from "../FooterButtons";
import StudentActivities from "../StudentActivities";
import PostDetail from "Post/routes/PostDetail";
import { ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION } from "Constants/permissionConstants";
import { useMediaQuery } from "Hooks";

const postCaptionTextClass = classNames({
  ["text-body-2"]: true,
  [classes.smallCardPostCaptionText]: true,
});

const postCaptionClass = classNames("text-body", {
  [classes.postCaptionTextV2]: true,
});

const postCaptionClassV2 = classNames("text-body", {
  [classes.journalPostCaptionTextV2]: true,
});

const style = {
  containerStyle: {
    width: "auto",
    maxWidth: "100%",
    alignSelf: "flex-start",
    paddingBottom: "16px",
    margin: "0",
    marginTop: "16px",
    borderWidth: 1,
    borderColor: colors.borderDefault,
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    height: "fit-content",
    alignItems: "center",
  },
  mediaPlaceholderContainerStyle: {
    width: "194px",
    height: "150px",
    padding: 0,
  },
  evaluationCardStyle: {
    minWidth: "194px",
    minHeight: "150px",
    maxHeight: "150px",
  },
  scrollButtonsContainerStyle: {
    height: "175px",
  },
  assessmentToolTextStyle: { fontSize: "1.4rem", marginTop: "4px" },
  sidePaneContainerStyle: { marginTop: "16px" },
  listContainerStyles: {
    marginTop: "16px",
    ...(isSafari() ? { willChange: "transform" } : {}),
  },
  usernameStyle: { fontWeight: "500" },
  dropDownContainerStyle: {
    paddingBottom: "16px",
  },
  carouselWrapperStyle: {
    position: "absolute",
    top: "95%",
    left: "50%",
    background: colors.textDefault,
    padding: " 4px",
    borderRadius: "12px",
    transform: "translate(-50%, -50%)",
  },
  noteContainerStyle: {
    width: 564,
    height: 300,
  },
  noteContainerStyleNew: {
    width: 564,
    minHeight: 80,
    height: "auto",
    maxHeight: 300,
  },
  attachmentContainerStyle: {
    width: 564,
    height: 512,
  },
  noteContainerStyleV2: {
    width: 550,
    height: 300,
  },
  newNoteContainerStyleV2: {
    width: 550,
    minHeight: 80,
    height: "auto",
    maxHeight: 300,
  },
  attachmentContainerStyleV2: (isIpadView = false) => ({
    width: isIpadView ? 408 : 550,
    height: 512,
  }),
  cardContainerV3Style: {
    padding: "24px",
    maxWidth: "600px",
    boxShadow: "none",
    borderRadius: "8px",
  },
  postCardTopMargin: {
    marginBottom: "16px",
  },

  postStatusContainerStyle: {
    marginInline: "-24px",
  },
  cascadeProfileStyle: {
    zIndex: "0",
    marginTop: "-32px",
  },
  activityContainerStyle: { paddingTop: "12px" },
  inApprovalButtonStyle: { marginRight: "4px", marginTop: "4px" },
};

const tooltipStyle = {
  color: colors.textDefault,
  fontSize: "1.6rem",
  fontWeight: "600",
  cursor: "pointer",
};

const tooltipStyleV2 = {
  color: "var(--neutral-200)",
  cursor: "pointer",
};

const tooltipLinkStyle = {
  textDecoration: "underline",
  ...tooltipStyle,
};

const tooltipLinkStyleV2 = {
  textDecoration: "underline",
  ...tooltipStyleV2,
};

const commentCacheVariables = { first: 1 };
const BLANK_ARRAY = [];
const BLANK_OBJECT = {};
const BLANK_STRING = "";
const singleTagContainerStyle = { padding: "4px 8px 4px 0" };
const WORKSHEET_TYPE = "worksheet";
const circleShapeProp = ["circle"];
const squareShapeProp = ["square"];

const getHeaderTextWithStudentTagged = ({
  LETitle,
  user,
  student,
  isStudentResponse,
  isStudentOwnResponse,
  isStudentTaggedWithNormalPost,
  onLEClick,
  handleKeyDownLE,
  studentsArray = [],
  canOpenLEPreview,
  resourceItem,
  setSharingModalOpen,
  currentUserId,
  t,
  isActivityPost = false,
  showAllStudentsInFilter,
  currentChildId,
  userType,
  isUpdatedSmallCard,
  customUserTextRef,
  toggleSharedAvatarPopover,
  isStudentFeedSmallCard,
}) => {
  const createdByName = getFormattedUserName({ user });
  const filteredStudentsArray = _.filter(
    studentsArray,
    student => student?.id != user?.id
  );
  const currentLoggedInUserId =
    userType === "parent" ? currentChildId : currentUserId;
  const currentUser = _.find(filteredStudentsArray, {
    id: currentLoggedInUserId,
  });
  const tooltip = _.reduce(
    filteredStudentsArray,
    (tooltip, student, index) => {
      if (index == 0) return "";
      tooltip += `${getFormattedUserName({ user: student })}<br/>`;
      return tooltip;
    },
    ""
  );

  const useAssessmentListContainerV2 =
    isPortfolioParityEnabledAndIsJournalRoute() ||
    (getIsEnableFamilyConsolidatedPortfolio() &&
      _.includes(window.location.href, "/family-portfolio-summary")) ||
    (showAcademicYearFilterProfilePortfolio() &&
      _.includes(window.location.href, "/studentFeed"));

  const assesmentLinkContainerClass = classNames(
    {
      [classes.assesmentLinkContainer]: !useAssessmentListContainerV2,
    },
    {
      [classes.assesmentLinkContainerV2]: useAssessmentListContainerV2,
    },
    { ["text-label"]: isPortfolioParityEnabledAndIsJournalRoute() },
    {
      [classes.noUnderlineAssessmentLink]:
        !canOpenLEPreview || isStudentFeedSmallCard,
    }
  );

  const openAudienceModal = () => {
    setSharingModalOpen(true);
  };

  const handleAudienceModalKeydown = e => {
    onEnterOrSpaceKeyDown(e, openAudienceModal);
  };

  const taggedAssesmentMessageClasses = classNames({
    [classes.taggedAssesmentMessageText]:
      !isPortfolioRevampAndIsJournalRoute() && !isUpdatedSmallCard,
    ["text-label"]: isPortfolioRevampAndIsJournalRoute() || isUpdatedSmallCard,
    [classes.taggedAssesmentMessageTextV2]: isPortfolioRevampAndIsJournalRoute(),
    [classes.smallCardTaggedText]: isUpdatedSmallCard,
  });

  const taggedCreatedByClasses = classNames({
    ["text-label"]: isPortfolioRevampAndIsJournalRoute() || isUpdatedSmallCard,
    [classes.taggedCreatedByTopContainerV2]:
      isPortfolioRevampAndIsJournalRoute() || isUpdatedSmallCard,
    [classes.taggedCreatedByTopContainer]:
      !isPortfolioRevampAndIsJournalRoute() && !isUpdatedSmallCard,
  });

  if (isStudentResponse) {
    if (isStudentOwnResponse) {
      return (
        <div>
          {/* Following <Trans> results: {student} shared thier own response to {assessment}  */}
          <p
            data-test-id="journal-feed-postcard-creatordetails"
            className={taggedAssesmentMessageClasses}
          >
            <Trans i18nKey={"journal:shared_own_response_to_journal"}>
              <b className={taggedCreatedByClasses}>
                {{ name: createdByName }}
              </b>
              <b
                className={assesmentLinkContainerClass}
                onClick={onLEClick}
                tabIndex={0}
                onKeyDown={handleKeyDownLE}
              >
                {{ label: LETitle }}
              </b>
            </Trans>
          </p>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex" }}>
          {/* Following <Trans> results: {teacher} shared {student}'s response to {assessment} */}
          <p
            data-test-id="journal-feed-postcard-creatordetails"
            className={taggedAssesmentMessageClasses}
          >
            {!_.size(filteredStudentsArray) || _.isEmpty(student) ? (
              <Trans i18nKey={"journal:teacher_tagged_le_message"}>
                <b className={taggedCreatedByClasses}>
                  {{ name: createdByName }}
                </b>
                <b
                  className={assesmentLinkContainerClass}
                  onClick={onLEClick}
                  tabIndex={0}
                  onKeyDown={handleKeyDownLE}
                >
                  {{ label: LETitle }}
                </b>
              </Trans>
            ) : (
              <Trans i18nKey={"journal:shared_response_to_journal"}>
                <b className={taggedCreatedByClasses}>
                  {{ createdBy: createdByName }}
                </b>
                <b className={taggedCreatedByClasses}>
                  {{
                    student: getFormattedUserName({ user: student }),
                  }}
                </b>
                <b
                  className={assesmentLinkContainerClass}
                  onClick={onLEClick}
                  tabIndex={0}
                  onKeyDown={handleKeyDownLE}
                >
                  {{ label: LETitle }}
                </b>
              </Trans>
            )}
          </p>
        </div>
      );
    }
  } else {
    if (!_.isNil(resourceItem) && !_.isEmpty(resourceItem)) {
      return (
        <div>
          {/* Following <Trans> results: {user} tagged {assessment} to the post */}
          {_.get(user, "type") == "student" ? (
            <p
              data-test-id="journal-feed-postcard-creatordetails"
              className={taggedAssesmentMessageClasses}
            >
              <Trans i18nKey="journal:teacher_tagged_le_message">
                <b className={taggedCreatedByClasses}>
                  {{ name: createdByName }}
                </b>
                <b
                  className={assesmentLinkContainerClass}
                  onClick={onLEClick}
                  tabIndex={0}
                  onKeyDown={handleKeyDownLE}
                >
                  {{ label: LETitle }}
                </b>
              </Trans>
            </p>
          ) : _.get(user, "type") == "staff" ? (
            isPortfolioParityEnabled() ? (
              <p
                data-test-id="journal-feed-postcard-creatordetails"
                className={taggedAssesmentMessageClasses}
              >
                {/* Following <Trans> results: {teacher} shared {student}'s response to {assessment} */}
                {_.isEmpty(filteredStudentsArray) ? (
                  <Trans i18nKey={"journal:teacher_tagged_le_message"}>
                    <b className={taggedCreatedByClasses}>
                      {{ name: createdByName }}
                    </b>
                    <b
                      tabIndex={0}
                      className={assesmentLinkContainerClass}
                      onClick={onLEClick}
                      onKeyDown={handleKeyDownLE}
                    >
                      {{ label: LETitle }}
                    </b>
                  </Trans>
                ) : null}

                {_.size(filteredStudentsArray) > 2 ? (
                  <Trans
                    i18nKey={
                      "journal:user_tagged_shared_response_to_journal_others"
                    }
                  >
                    <b className={taggedCreatedByClasses}>
                      {{ createdBy: createdByName }}
                    </b>
                    {currentLoggedInUserId == _.get(currentUser, "id") ? (
                      <b className={taggedCreatedByClasses}>
                        {{
                          student:
                            userType === "parent"
                              ? getFormattedUserName({
                                  user: _.find(filteredStudentsArray, {
                                    id: currentLoggedInUserId,
                                  }),
                                })
                              : t("common:you"),
                        }}
                      </b>
                    ) : (
                      <b className={taggedCreatedByClasses}>
                        {{
                          student: getFormattedUserName({
                            user: filteredStudentsArray[0],
                          }),
                        }}
                      </b>
                    )}
                    {showAllStudentsInFilter ? (
                      <span
                        style={
                          isPortfolioRevampAndIsJournalRoute() ||
                          isUpdatedSmallCard
                            ? tooltipLinkStyleV2
                            : tooltipLinkStyle
                        }
                        tabIndex={0}
                        className={classNames(classes.focusText, {
                          [classes.smallCardFocusText]: isUpdatedSmallCard,
                          "text-label": isUpdatedSmallCard,
                        })}
                        onClick={openAudienceModal}
                        onKeyDown={handleAudienceModalKeydown}
                      >
                        <LinkWithTooltip
                          tooltip={tooltip}
                          placement="bottom"
                          style={
                            isPortfolioRevampAndIsJournalRoute() ||
                            isUpdatedSmallCard
                              ? tooltipLinkStyleV2
                              : tooltipLinkStyle
                          }
                        >
                          <b className={classes.othersTooltipContainer}>
                            {{
                              remainingStudentsCount:
                                _.size(filteredStudentsArray) - 1,
                            }}
                          </b>
                        </LinkWithTooltip>
                      </span>
                    ) : (
                      <span style={tooltipStyle}>
                        {" "}
                        <b className={classes.othersTooltipContainer}>
                          {{
                            remainingStudentsCount:
                              _.size(filteredStudentsArray) - 1,
                          }}
                        </b>
                      </span>
                    )}
                    <b
                      className={assesmentLinkContainerClass}
                      tabIndex={0}
                      onClick={onLEClick}
                      onKeyDown={handleKeyDownLE}
                    >
                      {{ label: LETitle }}
                    </b>
                  </Trans>
                ) : null}

                {_.size(filteredStudentsArray) === 2 &&
                showAllStudentsInFilter ? (
                  <Trans
                    i18nKey={
                      "journal:user_tagged_shared_response_to_journal_tagged"
                    }
                  >
                    <b className={taggedCreatedByClasses}>
                      {{ createdBy: createdByName }}
                    </b>
                    {currentLoggedInUserId == _.get(currentUser, "id") ? (
                      <b className={taggedCreatedByClasses}>
                        {{
                          student1:
                            userType === "parent"
                              ? getFormattedUserName({
                                  user: _.find(filteredStudentsArray, {
                                    id: currentLoggedInUserId,
                                  }),
                                })
                              : t("common:you"),
                        }}
                      </b>
                    ) : (
                      <b className={taggedCreatedByClasses}>
                        {{
                          student1: getFormattedUserName({
                            user: filteredStudentsArray[0],
                          }),
                        }}
                      </b>
                    )}
                    <b className={taggedCreatedByClasses}>
                      {{
                        student2: getFormattedUserName({
                          user: filteredStudentsArray[1],
                        }),
                      }}
                    </b>
                    <b
                      className={assesmentLinkContainerClass}
                      tabIndex={0}
                      onKeyDown={handleKeyDownLE}
                      onClick={onLEClick}
                    >
                      {{ label: LETitle }}
                    </b>
                  </Trans>
                ) : _.size(filteredStudentsArray) === 2 ? (
                  <Trans
                    i18nKey={
                      "journal:user_tagged_shared_response_to_journal_single_tagged"
                    }
                  >
                    <b className={taggedCreatedByClasses}>
                      {{ createdBy: createdByName }}
                    </b>
                    {currentLoggedInUserId == _.get(currentUser, "id") ? (
                      <b className={taggedCreatedByClasses}>
                        {{
                          student:
                            userType === "parent"
                              ? getFormattedUserName({
                                  user: _.find(filteredStudentsArray, {
                                    id: currentLoggedInUserId,
                                  }),
                                })
                              : t("common:you"),
                        }}
                      </b>
                    ) : (
                      <b className={taggedCreatedByClasses}>
                        {{
                          student:
                            getFormattedUserName({
                              user: filteredStudentsArray[0],
                            }) ||
                            `${_.get(
                              filteredStudentsArray[0],
                              "firstName",
                              "student(s)"
                            )} ${_.get(
                              filteredStudentsArray[0],
                              "lastName",
                              ""
                            )}`,
                        }}
                      </b>
                    )}

                    <b
                      className={assesmentLinkContainerClass}
                      tabIndex={0}
                      onClick={onLEClick}
                      onKeyDown={handleKeyDownLE}
                    >
                      {{ label: LETitle }}
                    </b>
                  </Trans>
                ) : null}
                {_.size(filteredStudentsArray) === 1 ? (
                  <Trans
                    i18nKey={
                      "journal:user_tagged_shared_response_to_journal_single_tagged"
                    }
                  >
                    <b className={taggedCreatedByClasses}>
                      {{ createdBy: createdByName }}
                    </b>
                    {currentLoggedInUserId == _.get(currentUser, "id") ? (
                      <b className={taggedCreatedByClasses}>
                        {{
                          student:
                            userType === "parent"
                              ? getFormattedUserName({
                                  user: _.find(filteredStudentsArray, {
                                    id: currentLoggedInUserId,
                                  }),
                                })
                              : t("common:you"),
                        }}
                      </b>
                    ) : (
                      <b className={taggedCreatedByClasses}>
                        {{
                          student:
                            getFormattedUserName({
                              user: filteredStudentsArray[0],
                            }) ||
                            `${_.get(
                              filteredStudentsArray[0],
                              "firstName",
                              "student(s)"
                            )} ${_.get(
                              filteredStudentsArray[0],
                              "lastName",
                              ""
                            )}`,
                        }}
                      </b>
                    )}

                    <b
                      className={assesmentLinkContainerClass}
                      tabIndex={0}
                      onClick={onLEClick}
                      onKeyDown={handleKeyDownLE}
                    >
                      {{ label: LETitle }}
                    </b>
                  </Trans>
                ) : null}
              </p>
            ) : (
              <p
                data-test-id="journal-feed-postcard-creatordetails"
                className={taggedAssesmentMessageClasses}
              >
                {/* Following <Trans> results: {teacher} tagged {LE} to the post */}
                <Trans i18nKey={"journal:teacher_tagged_le_message"}>
                  <b className={taggedCreatedByClasses}>
                    {{ name: createdByName }}
                  </b>
                  <b
                    className={assesmentLinkContainerClass}
                    tabIndex={0}
                    onClick={onLEClick}
                    onKeyDown={handleKeyDownLE}
                  >
                    {{ label: LETitle }}
                  </b>
                </Trans>
              </p>
            )
          ) : (
            <div data-test-id="journal-feed-postcard-creatordetails">
              {createdByName}
            </div>
          )}
        </div>
      );
    }
    if (
      _.size(filteredStudentsArray, 0) > 0 &&
      !isActivityPost &&
      showAllStudentsInFilter
    ) {
      const remainingStudentCount = (
        <LinkWithTooltip
          tooltip={tooltip}
          placement="bottom"
          style={
            isPortfolioRevampAndIsJournalRoute()
              ? tooltipLinkStyleV2
              : tooltipLinkStyle
          }
        >
          <b className={classes.othersTooltipContainer}>
            {{
              remainingStudentsCount: _.size(filteredStudentsArray) - 1,
            }}
          </b>
        </LinkWithTooltip>
      );

      return (
        <div style={{ display: "flex" }}>
          {/* Following <Trans> results: {teacher} tagged {student} */}
          <p
            data-test-id="journal-feed-postcard-creatordetails"
            className={taggedAssesmentMessageClasses}
          >
            {_.size(filteredStudentsArray, 0) == 1 &&
              !(user?.type === "student" && userType === "parent") && (
                <Trans i18nKey={"journal:teacher_tagged_student"}>
                  <b className={taggedCreatedByClasses}>
                    {{ teacherName: createdByName }}
                  </b>
                  {currentUserId == _.get(currentUser, "id") &&
                  isPortfolioParityEnabledAndIsJournalRoute() ? (
                    <b className={taggedCreatedByClasses}>
                      {{
                        studentName:
                          userType === "parent"
                            ? getFormattedUserName({
                                user: _.find(filteredStudentsArray, {
                                  id: currentLoggedInUserId,
                                }),
                              })
                            : t("common:you"),
                      }}
                    </b>
                  ) : (
                    <b className={taggedCreatedByClasses}>
                      {{
                        studentName:
                          getFormattedUserName({
                            user: filteredStudentsArray[0],
                          }) || "student(s)",
                      }}
                    </b>
                  )}
                </Trans>
              )}

            {_.size(filteredStudentsArray, 0) == 2 && (
              <Trans i18nKey={"journal:user_tagged_student_and_student"}>
                <b className={taggedCreatedByClasses}>
                  {{ user: createdByName }}
                </b>
                {currentUserId == _.get(currentUser, "id") &&
                isPortfolioParityEnabledAndIsJournalRoute() ? (
                  <b className={taggedCreatedByClasses}>
                    {{
                      student1:
                        userType === "parent"
                          ? getFormattedUserName({
                              user: _.find(filteredStudentsArray, {
                                id: currentLoggedInUserId,
                              }),
                            })
                          : t("common:you"),
                    }}
                  </b>
                ) : (
                  <b className={taggedCreatedByClasses}>
                    {{
                      student1:
                        getFormattedUserName({
                          user: filteredStudentsArray[0],
                        }) || "student(s)",
                    }}
                  </b>
                )}
                <b className={taggedCreatedByClasses}>
                  {{
                    student2:
                      getFormattedUserName({
                        user: filteredStudentsArray[1],
                      }) || "student(s)",
                  }}
                </b>
              </Trans>
            )}

            {_.size(filteredStudentsArray, 0) > 2 && (
              <Trans i18nKey={"journal:user_tagged_student_and_others"}>
                <b className={taggedCreatedByClasses}>
                  {{ user: createdByName }}
                </b>
                {currentUserId == _.get(currentUser, "id") &&
                isPortfolioParityEnabledAndIsJournalRoute() ? (
                  <b className={taggedCreatedByClasses}>
                    {{
                      student:
                        userType === "parent"
                          ? getFormattedUserName({
                              user: _.find(filteredStudentsArray, {
                                id: currentLoggedInUserId,
                              }),
                            })
                          : t("common:you"),
                    }}
                  </b>
                ) : (
                  <b className={taggedCreatedByClasses}>
                    {{
                      student:
                        getFormattedUserName({
                          user: filteredStudentsArray[0],
                        }) || "student(s)",
                    }}
                  </b>
                )}
                {isPortfolioParityEnabled() ? (
                  <span
                    ref={customUserTextRef}
                    data-test-id="journal-feed-postcard-creatordetails-otherstext"
                    style={
                      isPortfolioRevampAndIsJournalRoute() || isUpdatedSmallCard
                        ? tooltipLinkStyleV2
                        : tooltipLinkStyle
                    }
                    onClick={
                      isUpdatedSmallCard
                        ? toggleSharedAvatarPopover
                        : openAudienceModal
                    }
                    tabIndex={0}
                    onKeyDown={
                      isUpdatedSmallCard
                        ? toggleSharedAvatarPopover
                        : openAudienceModal
                    }
                    className={classNames(classes.focusText, {
                      [classes.smallCardFocusText]: isUpdatedSmallCard,
                      "text-label": isUpdatedSmallCard,
                    })}
                  >
                    {remainingStudentCount}
                  </span>
                ) : (
                  remainingStudentCount
                )}
              </Trans>
            )}
          </p>
        </div>
      );
    }
    if (isStudentTaggedWithNormalPost || isActivityPost) {
      return (
        <div style={{ display: "flex" }}>
          {/* Following <Trans> results: {teacher} tagged {student} */}
          <p
            data-test-id="journal-feed-postcard-creatordetails"
            className={taggedAssesmentMessageClasses}
          >
            <Trans
              i18nKey={"journal:teacher_tagged_student"}
              className={isUpdatedSmallCard ? "text-label" : ""}
            >
              <b className={taggedCreatedByClasses}>
                {{ teacherName: createdByName }}
              </b>
              <b className={taggedCreatedByClasses}>
                {{
                  studentName:
                    currentLoggedInUserId == _.get(currentUser, "id") &&
                    userType !== "parent"
                      ? t("common:you")
                      : getFormattedUserName({ user: student }) || "student",
                }}
              </b>
            </Trans>
          </p>
        </div>
      );
    } else {
      return createdByName;
    }
  }
};

const TaggedElementPYP = props => {
  const {
    elementPYP = [],
    otherTags = [],
    hideElementPYP,
    toggleTagModal,
    t,
    goToRelativeRoute,
    maxOtherTagsToShow = 10,
    maxWidthForTag = "200px",
    customTagContainerStyle = {},
    isDSV2,
    isUpdatedSmallCard,
  } = props;

  const remainingCount = _.size(otherTags) - maxOtherTagsToShow;

  const shouldShowOtherTags = !_.isEmpty(otherTags),
    shouldShowElementPYP = _.size(elementPYP) > 0 && !hideElementPYP;

  const otherTagsToShow = _.slice(otherTags, 0, maxOtherTagsToShow);

  if (!shouldShowOtherTags && !shouldShowElementPYP) return null;

  const handleClick = route => e => {
    e.stopPropagation();
    if (!_.isNil(route)) {
      goToRelativeRoute({
        route: route,
      });
    }
  };

  const handleKeyDown = route => e => {
    onEnterOrSpaceKeyDown(e, handleClick(route));
  };

  const tagContainerClasses = classNames({
    [classes.tagContainer]: true,
    [classes.tagContainerV2]: isDSV2,
    [classes.tagContainerSmallCard]: isUpdatedSmallCard,
  });

  return (
    <div className={tagContainerClasses} style={customTagContainerStyle}>
      {shouldShowOtherTags
        ? _.map(otherTagsToShow, tag => {
            return (
              <Tooltip
                tooltip={_.get(tag, "label", "")}
                placement="top"
                key={_.get(tag, "label")}
              >
                <div
                  onClick={handleClick(tag?.route)}
                  onKeyDown={handleKeyDown(tag?.route)}
                  tabIndex={0}
                  className={classes.singleTag}
                  style={{ cursor: "pointer", maxWidth: maxWidthForTag }}
                >
                  <span className={classes.TaggedElementText}>
                    {_.get(tag, "label", "")}
                  </span>
                </div>
              </Tooltip>
            );
          })
        : null}
      {shouldShowOtherTags && remainingCount > 0 && (
        <div
          className={classes.singleTag}
          style={{ cursor: "pointer", minWidth: "fit-content" }}
        >
          <span className={classes.TaggedElementText}>
            {t("common:plus_with_count", {
              count: remainingCount,
            })}
          </span>
        </div>
      )}
      {shouldShowElementPYP &&
        _.map(TAGGABLE_PROJECT_ELEMENTS, element => {
          const fieldData = _.find(elementPYP, {
            fieldUID: element?.value,
          });
          const fieldDataCount = _.size(_.get(fieldData, "value"));

          let tagLabel = "";
          let onClickTag = _.noop;
          const labels = _.map(
            _.filter(
              _.get(fieldData, "resolvedMinimalTree.nodes", BLANK_ARRAY),
              node =>
                _.includes(_.get(fieldData, "value", BLANK_ARRAY), node.id)
            ),
            item => {
              const { label, type } = item;
              const displayName = _.get(
                item,
                ["metadata", "display_name"],
                null
              );

              return getIsTypeOfProjectPortfolioLOs({ type }) &&
                displayName &&
                !_.includes(label, displayName)
                ? `${displayName}: ${label}`
                : label;
            }
          );

          switch (element.value) {
            case TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP:
            case TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP:
            case TEMPLATE_FIELD_SL_LEARNING_OUTCOMES_DP:
            case TEMPLATE_FIELD_CE_LEARNING_OUTCOMES_DP:
            case TEMPLATE_FIELD_CE_PROCESS_STAGES:
            case TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS:
            case TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES:
              //if the field type is service action outcomes then we want to show that all outcomes.
              return fieldDataCount > 0
                ? _.map(labels, label => (
                    <Tooltip key={label} placement="top" tooltip={label}>
                      {isDSV2 ? (
                        <Tag color="neutral" shouldTruncate>
                          <div className={classes.tag}>{label}</div>
                        </Tag>
                      ) : (
                        <div className={classes.singleTag} onClick={onClickTag}>
                          <span className={classes.TaggedElementText}>
                            {label}
                          </span>
                        </div>
                      )}
                    </Tooltip>
                  ))
                : null;
            default:
              onClickTag = e => {
                e.stopPropagation();
                _.isFunction(toggleTagModal) && toggleTagModal(element.value);
              };
              tagLabel = t(element.tagCountLabel, {
                count: fieldDataCount,
              });
              return fieldDataCount > 0 ? (
                <Tooltip key={tagLabel} placement="top" tooltip={tagLabel}>
                  <div
                    className={classes.singleTag}
                    style={{ cursor: "pointer" }}
                    onClick={onClickTag}
                  >
                    <span className={classes.TaggedElementText}>
                      {tagLabel}
                    </span>
                  </div>
                </Tooltip>
              ) : null;
          }
        })}
    </div>
  );
};

const EditDateModal = props => {
  const {
    editDateDetails,
    setEditDateDetails,
    updatePostDate,
    post,
    isProjectPost = false,
    t,
  } = props;

  const styles = {
    buttonStylesV2: { marginRight: "8px" },
    buttonStyles: { marginRight: "12px" },
  };
  const confirmShortcuts = { code: "Enter", shiftKey: true };

  const handlePostDateChange = value => {
    const currentState = { ...editDateDetails };
    setEditDateDetails({ ...currentState, date: value });
  };

  const handlePostTimeChange = value => {
    const currentState = { ...editDateDetails };
    setEditDateDetails({ ...currentState, time: value });
  };

  const onCloseEditDateModal = () => {
    setEditDateDetails({ showEditDateModal: false });
  };

  const onConfirmDateChange = () => {
    const newDateTime = _.omit(editDateDetails, ["showEditDateModal"]);
    const date = _.get(newDateTime, "date");
    const time = _.get(newDateTime, "time");

    if (
      !_.isNil(date) &&
      !_.isNil(time) &&
      moment(date).isValid() &&
      moment(time).isValid() &&
      moment(
        moment(date.format("YYYY-MM-DD") + " " + time.format("HH:mm"))
      ).isSameOrBefore(moment())
    ) {
      updatePostDate({
        ...newDateTime,
        postDetails: post,
        isProjectPost: isProjectPost,
      }); // send post id, new date and time in the argument
      onCloseEditDateModal();
    }
  };

  if (!isPortfolioParityEnabled()) {
    return editDateDetails?.showEditDateModal ? (
      <UIModal isOpen={true} modalContent={classes.editDateModalContainer}>
        <div className={classes.editDateModalInnerContainer}>
          <div className={classes.editDateModalHeader}>
            <div className="d-flex flex-column">
              <div className="heading-4">
                {" "}
                {t("common:edit_with_label", {
                  label: t("common:date"),
                })}{" "}
              </div>
              <div className="text-body-1 text-subtle pt-2">
                {" "}
                {t("common:edit_post_date_modal")}
              </div>
            </div>
            <IconButton
              icon={<CloseOutlined />}
              variant="plain"
              onClick={onCloseEditDateModal}
            />
          </div>
          <div className={classes.editDateModalBody}>
            <div className={classes.dateContainer}>
              <DatePicker
                label={t("common:date")}
                onChange={handlePostDateChange}
                picker="date"
                value={_.get(editDateDetails, "date")}
                size="large"
                variant="outlined"
                maxDate={moment()}
              />
            </div>
            <div className={classes.dateContainer}>
              <TimePicker
                label={t("common:time")}
                value={_.get(editDateDetails, "time")}
                onChange={handlePostTimeChange}
                format="HH:mm"
                size={"large"}
                placement={"down"}
              />
            </div>
          </div>
          <div className={classes.editDateModalFooter}>
            <Button
              size="large"
              variant="outlined-subtle"
              style={styles.buttonStyles}
              onClick={onCloseEditDateModal}
            >
              {t("common:cancel")}
            </Button>
            <Button
              size="large"
              variant="progressive"
              onClick={onConfirmDateChange}
            >
              {t("common:confirm")}
            </Button>
          </div>
        </div>
      </UIModal>
    ) : null;
  }

  return editDateDetails?.showEditDateModal ? (
    <Modal
      dsVersion="2.0"
      onClose={onCloseEditDateModal}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      hasOverlay={true}
      width="480px"
      height="fit-content"
    >
      <Modal.Header
        title={t("common:edit_with_label", {
          label: t("common:date"),
        })}
        subtitle={t("common:edit_post_date_modal")}
        isClosable={true}
      />
      <Modal.Body isScrollable={true}>
        <div>
          <div className={classes.dateContainerV2}>
            <DatePicker
              dsVersion="2.0"
              label={t("common:date")}
              onChange={handlePostDateChange}
              picker="date"
              value={_.get(editDateDetails, "date")}
              size="large"
              variant="outlined"
              maxDate={moment()}
              testId="journal-feed-editdate"
            />
          </div>
          <div className={classes.dateContainerV2}>
            <TimePicker
              dsVersion="2.0"
              label={t("common:time")}
              value={_.get(editDateDetails, "time")}
              onChange={handlePostTimeChange}
              format="HH:mm"
              size="large"
              placement={"down"}
              testId="journal-feed-edittime"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.editDateModalFooterV2}>
          <Button
            dsVersion="2.0"
            size="medium"
            variant="neutral"
            type="outlined"
            style={styles.buttonStylesV2}
            onClick={onCloseEditDateModal}
            testId="journal-feed-editdate-cancel"
          >
            {t("common:cancel")}
          </Button>
          <Button
            dsVersion="2.0"
            size="medium"
            variant="primary"
            onClick={onConfirmDateChange}
            testId="journal-feed-editdate-confirm"
            shortcut={confirmShortcuts}
          >
            {t("common:confirm")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  ) : null;
};

const postRatedLearningGoalsDetails = ({
  post,
  curriculumProgramType,
  showPostLearningGoals,
}) => {
  return showPostLearningGoals
    ? {
        elementPYP: _.get(post, "elementPYP"),
        curriculumProgramType: curriculumProgramType,
        showLearningGoalsEditor: false,
        showLearningGoalsPreview: true,
        propsIbPypElementRatings: _.get(post, "ibPYPElementRatings"),
        academicTerm: _.get(post, "academicTerm"),
      }
    : {};
};

const responsiveSettings = [
  {
    breakpoint: 1440,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  },
  {
    breakpoint: 1420,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
  },
  {
    breakpoint: 1200,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
  },
  {
    breakpoint: 960,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 350,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
];

const ModelContent = React.memo(
  ({
    attachments,
    toggleMediaModal,
    showMediaModal,
    activeIndex,
    toggleDownloadBeginOverlay,
    t,
    curriculumProgramType,
    post,
    isStudentResponse,
    canCreateComment,
    postViewMode,
    updatePostStatus,
    onPostActionClick,
    onPostSidePaneCloseClick,
    fromPropsActivitySelectedStudentId,
    fromPropsHandleActivitySelectedStudentChange,
    fromPropsHandleActivitySelectedStudentAttachmentsChange,
    staffEditAccess = true,
    hideViews = false,
    hideLike,
    hideComments,
    hideLearninGoals,
    hideTaggedStudents,
    hideUnitDetails,
    showTaggedFolders,
    taggedStudents,
    showPostLearningGoals,
    canDownloadMedia = true,
    sourceType,
    paramPostId,
    isViewFromPostPage,
    openedFromNotification,
    canEditOrDelete,
    canAddComments,
    hasManageAccess,
    isActivityPost,
  }) => {
    const parentRef = useRef(null);
    const onCloseClickLocal = useCallback(value => {
      if (_.isFunction(onPostSidePaneCloseClick)) onPostSidePaneCloseClick();
      fromPropsHandleActivitySelectedStudentChange("");
      toggleMediaModal(value);
    }, []);

    const onDiscardDirectly = useCallback(() => {
      onCloseClickLocal(false);
    }, []);

    const onCloseClick = () => {
      onCloseClickLocal(false);
    };

    const mediaAttachments = useMemo(() => ({ attachments: attachments }), [
      attachments,
    ]);

    const postId = sourceType == "PUBLIC_URL" ? paramPostId : post?.id;
    return showMediaModal ? (
      showNewTheatreMode() ? (
        !isStudentResponse ? (
          <div ref={parentRef}>
            <TheatreModeV2
              mediaAttachments={mediaAttachments}
              activeAttachmentIndex={activeIndex}
              toggleTheatreMode={onCloseClickLocal}
              iframeIdSelector={"workbook-iframe-journal"}
              onDiscardDirectly={onDiscardDirectly}
              postRatedLearningGoalsDetails={postRatedLearningGoalsDetails({
                post,
                curriculumProgramType,
                showPostLearningGoals: showPostLearningGoals,
              })}
              taggedStudents={taggedStudents}
              canDownloadMedia={canDownloadMedia}
              isActivityPost={isActivityPost}
              sidePaneContent={
                // PostDetail will receive setTheatreAttachmentIndex(index), theatreActiveAttachmentIndex, setTheatreAttachmentById({id, type}) and theatreActiveAttachmentId as a props.
                <PostDetail
                  postId={postId}
                  onCloseClick={onCloseClick}
                  showComment={false} // false to not show comments screen initially
                  customDetailText={t("common:view_with_label_lowercase", {
                    label: t("common:post"),
                  })}
                  canAddComments={canAddComments}
                  isRightPaneChat={true}
                  mediaMaxHeight={480}
                  canCreateComment={canCreateComment}
                  isSidePaneContent={true}
                  mode={postViewMode ? "edit" : "view"}
                  showCloseBtn={false}
                  showCommentBackButton={true}
                  showAttachmentAsMediaCard={true}
                  updatePostStatus={updatePostStatus}
                  onPostActionClick={onPostActionClick}
                  fromPropsActivitySelectedStudentId={
                    fromPropsActivitySelectedStudentId
                  }
                  fromPropsHandleActivitySelectedStudentAttachmentsChange={
                    fromPropsHandleActivitySelectedStudentAttachmentsChange
                  }
                  staffEditAccess={staffEditAccess}
                  hideViews={hideViews}
                  hideLike={hideLike || !staffEditAccess}
                  hideComments={hideComments || !staffEditAccess}
                  hideLearninGoals={hideLearninGoals}
                  hideTaggedStudents={hideTaggedStudents}
                  hideUnitDetails={hideUnitDetails}
                  showTaggedFolders={showTaggedFolders}
                  isViewFromPostPage={isViewFromPostPage}
                  openedFromNotification={openedFromNotification}
                  canEditOrDelete={canEditOrDelete}
                  hasManageAccess={hasManageAccess}
                />
              }
            />
          </div>
        ) : null
      ) : (
        <MediaModal
          toggleMediaModal={toggleMediaModal}
          attachments={attachments}
          activeIndex={activeIndex}
          toggleDownloadBeginOverlay={toggleDownloadBeginOverlay}
          videoAutoPlayOnClick={true}
          showDownloadVideoButton={true}
        />
      )
    ) : null;
  }
);
ModelContent.displayName = "ModelContent";

const SubjectJournalCard = React.memo(props => {
  const {
    cardType,
    post,
    canEditOrDelete,
    onPostActionClick,
    isArchivedClass,
    userType,
    showTranslation,
    showTranslationButton,
    setShowTranslation,
    translatedText,
    showCommentButton,
    isProjectPostCard = false,
    t,
    currentUserId,
    currentChildId,
    otherTags = [],
    maxOtherTagsToShow,
    maxWidthForTag,
    customTagContainerStyle,
    hideElementPYP,
    toggleTagModal,
    goToRelativeRoute,
    isRightPaneCard = false,
    isAttachmentsSliderResponsive = true,
    updatePostDate,
    isViewFromPostPage = false,
    showCloseBtn,
    onCloseClick,
    isSidePaneContent = false,
    setTheatreAttachmentIndex,
    theatreActiveAttachmentId,
    setTheatreAttachmentById,
    showAttachmentAsMediaCard = false,
    cardContainerStyle: customCardContainerStyle = "",
    alwaysShowComment,
    customTagComponent = null,
    openedFromNotification = false,
    canAddComments = true,
    postObserverRef,
    postFragment = PostCommentFragment,
    showBadge = false,
    showViewCommentButtonText,
    showViewCommentButtonAtTop,
    canDownloadMedia = true,
    hideComments,
    hideLike,
    hideViews,
    currentCurriculumProgramId,
    isStudentArchived,
    hideMoveToDraftOption,
    defaultAccodianExpanded,
    children,
    showPostLearningGoals,
    curriculumProgramType,
    isApprovalRequiredForStudentPosts,
    staffEditAccess = true,
    fromPropsActivitySelectedStudentId,
    filteredStudentActivities,
    userId,
    currentCommentPostId,
    showTaggedFolders,
    hideUnitDetails,
    hideTaggedStudents,
    hideLearninGoals,
    defaultStudentNameOrderPreference,
    showAllStudentsInFilter,
    defaultStudentIdentifierNamePreference,
    openMediaOnLoad,
    postFilters,
    isUserAllowedToPublishPost,
    isPostCtaDisabled = false,
    courseTitle,
    testId,
    unobservePost,
    hasManageAccess,
    hasManageAccessForStudentPortfolioFromProps,
    cardHeaderStyle = {},
    extensionTagSize = "x-small",
    isUpdatedSmallCard,
    showShareWith = true,
    markPostAsSeenByUser,
    addPostAsSeen,
    learningCourseId,
    studentId,
  } = props;
  const { dsVersion } = useDSContext();
  const isDSV2 = dsVersion === "2.0";
  const postCardRef = useRef();
  const [slidesToManage, setSlidesToManage] = useState(1);
  const [refetchComment, setRefetchComment] = useState(false);
  const [showLikesModal, setShowLikesModal] = useState(false);
  const [showViewsModal, setShowViewsModal] = useState(false);
  const [isSharingModalOpen, setSharingModalOpen] = useState(false);
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showDownloadBeginOverlay, setShowDownloadBeginOverlay] = useState(
    false
  );
  const [titleText, setTitleText] = useState(_.get(post, "title", ""));
  const [attachments, setAttachments] = useState(_.get(post, "attachments"));
  const [activitySelectedStudentId, setActivitySelectedStudentId] = useState(
    !_.isEmpty(_.get(props, "fromPropsActivitySelectedStudentId", ""))
      ? _.get(props, "fromPropsActivitySelectedStudentId", "")
      : _.get(
          props,
          ["filteredStudentActivities", 0, "item", "activityStudent", "id"],
          ""
        )
  );
  const [showTranslatedText, setShowTranslatedText] = useState(false);
  const getStudents = taggedStudents => {
    return _.map(taggedStudents, item => {
      return _.get(item, "node", {});
    });
  };

  const isTablet = useMediaQuery(TABLET_LANDSCAPE_MEDIA_QUERY);
  const isStudentFeedSmallCard =
    (showAcademicYearFilterProfilePortfolio() &&
      _.includes(window.location.href, "/studentFeed")) ||
    (getIsEnableFamilyConsolidatedPortfolio() &&
      _.includes(window.location.href, "/family-portfolio-summary"));

  const cardFooterClass = classNames({
    [classes.footerContainer]: true,
    [classes.footerContainerSidePane]: isSidePaneContent,
  });

  const [sharedAvatarPopoverIsOpen, setSharedAvatarPopoverIsOpen] = useState(
    false
  );
  const customUserTextRef = useRef(null);

  const isStudentFeedRoute = hasIncludeGivenPathInCurrentRoute({
    path: "/studentFeed",
  });

  const isParentFeedRoute = hasIncludeGivenPathInCurrentRoute({
    path: "/family-portfolio-summary",
  });
  const toggleSharedAvatarPopover = () => {
    setSharedAvatarPopoverIsOpen(!sharedAvatarPopoverIsOpen);
  };

  const onAvatarPopoverClose = () => {
    setSharedAvatarPopoverIsOpen(false);
  };
  const getFormattedPopoverData = students => {
    if (_.isEmpty(students)) return [];

    return _.map(students, studentEdge => {
      const student = studentEdge.node;

      return {
        id: student.id,
        name: getFormattedUserName({ user: student }),
        profileImage: student.profileImage,
        color: student.color || "",
        iconType: "",
        AvatarIcon: null,
        isUserType: true,
      };
    });
  };

  const toggleTranslatedText = () => {
    setShowTranslatedText(!showTranslatedText);
  };

  useEffect(() => {
    const currentCardWidth = postCardRef?.current
      ? postCardRef?.current?.offsetWidth
      : 0;
    if (currentCardWidth >= 980) {
      setSlidesToManage(4);
    } else if (currentCardWidth >= 745) {
      setSlidesToManage(3);
    } else if (currentCardWidth >= 515) {
      setSlidesToManage(2);
    } else {
      setSlidesToManage(1);
    }

    if (
      userType === "parent" &&
      !_.includes(
        _.map(_.get(post, "seen.edges"), "node.user.id"),
        userId ? userId : currentUserId
      ) &&
      (isViewFromPostPage === false || isParentFeedRoute || isStudentFeedRoute)
    ) {
      if (isParentFeedRoute || isStudentFeedRoute) {
        addPostAsSeen({
          parentIds: [_.get(post, "id")],
          userId: userId ? userId : currentUserId,
        });
      } else {
        markPostAsSeenByUser({
          parentIds: [_.get(post, "id")],
          userId: userId ? userId : currentUserId,
          postDetails: post,
        });
      }
    }
    if (openMediaOnLoad) {
      setShowTheatreView(true);
    }
  }, []);

  const postCreator = _.get(post, "createdBy", BLANK_OBJECT);

  const postCreatorName = getFormattedUserName({
    user: postCreator,
  });
  const postDate =
    _.get(post, "state", "DRAFT") == "PUBLISHED" ||
    _.get(post, "state", "DRAFT") == "SCHEDULED"
      ? _.get(post, "publishedAt")
      : _.get(post, "createdAt");
  const sinceDateText =
    _.get(post, "state") == "SCHEDULED"
      ? t("common:scheduled_for_with_label", {
          label: moment(postDate).format("MMM DD YYYY, hh:mm A"),
        })
      : getDateAndTimeSince({
          date: postDate,
          format: DATE_TIME_CONSTANTS.D_MMM_YYYY_h_mm_a,
          t,
        });
  const tags = _.get(post, "folders", BLANK_ARRAY);

  const [showCommentBox, setShowCommentBox] = useState(false);
  const commentBoxRef = useRef();

  //--- LE response related data ----
  const items = _.get(post, "items", BLANK_ARRAY);
  const postEntity = _.get(
    getTaggedAssessment(_.get(post, "postTaggedEntity")),
    "entity",
    BLANK_OBJECT
  );

  const resourceItem =
    getIsNewGoalTaggingEnabled() &&
    isAssessmentTagged(_.get(post, "postTaggedEntity"))
      ? postEntity
      : _.get(post, "resourceItem", BLANK_ARRAY);
  const assesmentData = _.find(
    items,
    item => _.get(item, "itemType", "") === "STUDENT_ASSIGNMENT"
  );
  const assessmentItem = _.get(assesmentData, "item", BLANK_OBJECT);
  const content = _.get(assessmentItem, "assignment.content", BLANK_OBJECT);
  const assessmentId = _.get(content, "id", "");
  const studentData = _.get(assessmentItem, "student", BLANK_OBJECT);

  const isStudentOwnResponse =
    _.get(studentData, "id", "") == _.get(postCreator, "id");
  const isStudentResponse = !_.isEmpty(assesmentData);
  const isStudentTaggedWithNormalPost =
    !isStudentResponse &&
    _.size(_.get(post, "students.edges", [])) > 0 &&
    ((userType == "student" && _.get(postCreator, "id") != currentUserId) ||
      (userType == "parent" && _.get(postCreator, "id") != currentChildId) ||
      (userType == "staff" &&
        _.get(postCreator, "id") != _.get(post, "students.edges.0.node.id")));

  const canOpenLEPreview = () => {
    const showLEPreview =
      userType !== "parent"
        ? true
        : getSettingValue({
            name: "FamilyCanViewTaggedLearningExperience",
            currentCurriculumProgramId,
          });

    return showLEPreview;
  };
  const onLEClick = () => {
    canOpenLEPreview() &&
      onPostActionClick({
        id: _.get(post, "id"),
        action: "LE_PREVIEW",
        assessmentId:
          !_.isNil(assessmentId) && !_.isEmpty(assessmentId)
            ? assessmentId
            : _.get(resourceItem, "id", ""),
      });
  };

  const handleKeyDownLE = useKeyDownWrapper(onLEClick);

  const [editDateDetails, setEditDateDetails] = useState({
    showEditDateModal: false,
  });

  const [showTheatreView, setShowTheatreView] = useState(false);

  const onEditDateClick = () => {
    const dateTime = _.get(
      post,
      _.get(post, "state") == "PUBLISHED" ? "publishedAt" : "createdAt"
    );
    setEditDateDetails({
      showEditDateModal: true,
      date: moment(dateTime),
      time: moment(dateTime),
      state: _.get(post, "state"),
      id: _.get(post, "id"),
    });
  };
  const getStudentTaggedInformation = () => {
    const isCreatedByStudent = _.get(postCreator, "type") === "student";
    if (userType == "staff") {
      return _.size(_.get(post, "students.edges", []), 0) > 0
        ? isCreatedByStudent
          ? _.get(post, "students.edges[1].node", {})
          : _.get(post, "students.edges[0].node", {})
        : {};
    } else if (showAllStudentsInFilter || userType === "parent") {
      if (_.size(_.get(post, "students.edges", []), 0) > 0) {
        const excludeSelfFromStudents = _.filter(
          _.get(post, "students.edges", []),
          item => !_.isEqual(_.get(item, "node.id"), _.get(postCreator, "id"))
        );
        if (isCreatedByStudent && userType !== "parent") {
          return _.get(postCreator, "id") ===
            (userType !== "parent" ? currentUserId : currentChildId)
            ? _.get(excludeSelfFromStudents, "[0].node")
            : _.find(
                excludeSelfFromStudents,
                item =>
                  _.get(item, "node.id") ===
                  (userType !== "parent" ? currentUserId : currentChildId)
              )?.node;
        }
        return (
          _.find(
            _.get(post, "students.edges", []),
            item =>
              _.get(item, "node.id") ===
              (userType !== "parent" ? currentUserId : currentChildId)
          )?.node || _.first(_.get(post, "students.edges", []))?.node
        );
      }
    } else {
      return _.find(
        _.get(post, "students.edges", []),
        item =>
          _.get(item, "node.id") ===
          (userType !== "parent" ? currentUserId : currentChildId)
      )?.node;
    }
  };

  const userObject = getStudentTaggedInformation();
  const customUserText = getHeaderTextWithStudentTagged({
    LETitle: _.get(
      content,
      "title.value",
      _.get(resourceItem, "title.value", "assessment")
    ),
    student: isStudentTaggedWithNormalPost
      ? isPortfolioParityEnabled()
        ? userObject
        : _.get(post, "students.edges.0.node", BLANK_OBJECT)
      : studentData,
    user: postCreator,
    defaultStudentNameOrderPreference,
    isStudentResponse,
    isStudentOwnResponse,
    isStudentTaggedWithNormalPost,
    studentsArray: _.map(_.get(post, "students.edges", BLANK_OBJECT), student =>
      _.get(student, "node")
    ),
    onLEClick,
    handleKeyDownLE,
    canOpenLEPreview: canOpenLEPreview(),
    resourceItem: resourceItem,
    setSharingModalOpen,
    currentUserId,
    t,
    isActivityPost:
      !_.isEmpty(filteredStudentActivities) && !_.isEqual(userType, "staff"),
    showAllStudentsInFilter,
    currentChildId,
    userType,
    defaultStudentIdentifierNamePreference,
    isUpdatedSmallCard,
    customUserTextRef,
    toggleSharedAvatarPopover,
    isStudentFeedSmallCard,
  });

  const onCardClick = e => {
    e?.stopPropagation();
    if (
      showNewTheatreMode() &&
      isSidePaneContent == false &&
      !_.size(filteredStudentActivities)
    ) {
      if (unobservePost) {
        unobservePost(post?.id);
      }
      setShowTheatreView(true);
    }
  };

  const isJournalRoute = hasIncludeGivenPathInCurrentRoute({
    path: "/journal",
  });

  const showPortfolioParityCard =
    isPortfolioParityEnabled() &&
    (isJournalRoute ||
      isStudentFeedRoute ||
      isParentFeedRoute ||
      isPortfolioReviewSetupEnabledAndIsReviewRoute());
  const fetchAudioAttachment = () => {
    return _.filter(_.get(post, "attachments", []), { type: "AUDIO" });
  };

  const postId = _.get(post, "id");
  const showPostBadge = !_.get(post, "isRead", true) && showBadge;
  const isRnpEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);

  const hasManageAccessForStudentPortfolio =
    _.includes(window.location.href, "/studentFeed") &&
    isRnpEnabled &&
    userType === "staff"
      ? isSidePaneContent
        ? hasManageAccessForStudentPortfolioFromProps || hasManageAccess
        : _.get(
            _.first(_.get(post.course, "aclControlParameters")),
            "value",
            true
          )
      : true;
  useEffect(() => {
    if (postObserverRef?.current && postCardRef?.current && showBadge) {
      postObserverRef?.current?.observe(postCardRef?.current);
    }
  }, [postObserverRef?.current]);

  const cardContainerStyle = useMemo(() => {
    if (customCardContainerStyle) {
      return customCardContainerStyle;
    } else if (isRightPaneCard) {
      return {
        boxShadow: "none",
        marginBottom: "0",
        padding: "16px",
        marginTop: "8px",
      };
    } else if (isSidePaneContent) {
      return {
        boxShadow: "none",
        marginBottom: "0",
        border: "none",
        padding: "16px 18px 32px",
        minWidth: "unset",
      };
    } else return {};
  }, [isSidePaneContent, isRightPaneCard, customCardContainerStyle]);

  const [showPostScheduleModal, setShowPostScheduleModal] = useState(false);
  const onClosePostScheduleModal = () => {
    setShowPostScheduleModal(false);
  };

  const tagFolderContainerStyle = useMemo(
    () => ({
      marginTop: _.get(post, "attachments.length", 0) > 0 ? "10px" : "16px",
    }),
    []
  );

  const tagFolderContainerSmallCardStyle = useMemo(
    () => ({
      marginTop: _.get(post, "attachments.length", 0) > 0 ? "0px" : "12px",
    }),
    []
  );

  const onConfirmDateChange = ({ date, time }) => {
    if (
      !_.isNil(date) &&
      !_.isEmpty(date) &&
      !_.isNil(time) &&
      !_.isEmpty(time)
    ) {
      _.isFunction(onPostActionClick)
        ? onPostActionClick({
            id: _.get(post, "id"),
            action: "SCHEDULE_POST",
            params: {
              publishedAt: moment(
                date.format("YYYY-MM-DD") + " " + time.format("HH:mm")
              ),
            },
          })
        : null;
      setShowPostScheduleModal(false);
    }
  };
  useEffect(() => {
    openedFromNotification && setShowTheatreView(openedFromNotification);
  }, [openedFromNotification]);

  useEffect(() => {
    _.get(props, "fromPropsActivitySelectedStudentId", "") &&
      setActivitySelectedStudentId(fromPropsActivitySelectedStudentId);
  }, [fromPropsActivitySelectedStudentId]);

  const onCloseTheatreMode = () => {
    if (hideComments) return;
    syncPostCommentsCache({
      postId: _.get(post, "id"),
      variables: commentCacheVariables,
      fragment: postFragment,
    });
  };
  const commentsFromProps = useMemo(() => {
    return _.size(_.get(post, "comments.unreadCommentsEdges", BLANK_ARRAY)) > 0
      ? _.get(post, "comments.unreadCommentsEdges", BLANK_ARRAY)
      : _.get(post, "comments.edges", BLANK_ARRAY);
  }, [post]);

  const shouldHidePostCardToFamily = ({
    assessment,
    curriculumProgramId,
    userType,
  }) => {
    if (userType != "parent") return false;
    if (_.isEmpty(assessment)) return false;
    const hasAssessmentTool =
      _.size(
        _.get(
          assessment,
          "assignment.content.assessmentTools.edges",
          BLANK_ARRAY
        )
      ) > 0;
    const hasAttachmentsInResponse =
      _.size(_.get(assessment, "submission.attachmentGroups", BLANK_ARRAY)) > 0;

    return (
      userType == "parent" &&
      // hasAssessmentTool && // keeping this for reference
      !hasAttachmentsInResponse &&
      getSettingValue({
        name: "FamilyCanViewEvaluation",
        currentCurriculumProgramId: curriculumProgramId,
      }) == false
    );
  };

  const likedByFooterTextName =
    _.get(post, "likes.edges[0].node.user.id", 0) == currentUserId
      ? t("common:lowercase", { text: t("common:you") })
      : getFormattedUserName({
          user: _.get(post, "likes.edges[0].node.user", BLANK_OBJECT),
        });
  const closeSeenLikeModal = () => {
    if (showLikesModal) {
      setShowLikesModal(false);
    }
    if (showViewsModal) setShowViewsModal(false);
  };

  const toggleLikesModal = state => {
    setShowLikesModal(state);
  };

  const toggleViewsModal = state => {
    setShowViewsModal(state);
  };

  const workSheetAttachments = useMemo(() => {
    return _.filter(attachments, item =>
      _.get(item, "metadata.isWorksheetResponse", false)
    );
  }, [attachments]);

  const studentResponseV2 = (extraProps = {}) => {
    const isWorksheetPost =
      _.get(post, "resourceItem.assessmentType.value") === WORKSHEET_TYPE ||
      (isAssessmentTagged(_.get(post, "postTaggedEntity")) &&
        _.get(
          _.first(_.get(post, "postTaggedEntity")),
          "entity.assessmentType.value"
        ) === WORKSHEET_TYPE);

    return (
      <StudentResponseV2
        item={assessmentItem}
        post={post}
        postIdFromParent={
          _.get(props, "sourceType") == "PUBLIC_URL"
            ? _.get(props, "params.postId")
            : undefined
        }
        workSheetPostAttachments={
          isWorksheetPost ? workSheetAttachments : BLANK_ARRAY
        }
        showSeeMore={true}
        containerStyle={style.containerStyle}
        mediaPlaceholderContainerStyle={style.mediaPlaceholderContainerStyle}
        attachmentCardWidth={194}
        evaluationCardStyle={style.evaluationCardStyle}
        scrollButtonsContainerStyle={style.scrollButtonsContainerStyle}
        showEvaluation={true}
        onClickResponse={_.noop}
        isPreviewCard={true}
        isSidePaneContent={isSidePaneContent}
        showFullWidthItems={false}
        iconSize={"x-small"}
        assessmentToolTextStyle={style.assessmentToolTextStyle}
        canUserSeeRateLearningGoals={canOpenLEPreview()}
        sidePaneContainerStyle={style.sidePaneContainerStyle}
        setTheatreAttachmentIndex={setTheatreAttachmentIndex}
        theatreActiveAttachmentId={theatreActiveAttachmentId}
        setTheatreAttachmentById={setTheatreAttachmentById}
        setRefetchComment={setRefetchComment}
        hideComments={hideComments}
        hideLike={hideLike}
        hideViews={hideViews}
        onPostActionClick={onPostActionClick}
        showTheatreModeOnInit={showTheatreView}
        toggleParentMediaModalState={setShowTheatreView}
        canEditOrDelete={canEditOrDelete}
        hideMoveToDraftOption={hideMoveToDraftOption}
        isPostFeed={true}
        learningCourseId={
          learningCourseId ||
          _.get(_.first(_.get(post, "course.learningCourse", "")), "id", "")
        }
        {...extraProps}
      />
    );
  };

  const postRatedLearningGoalsDetails = ({
    post,
    curriculumProgramType,
    showPostLearningGoals,
    learningCourseIdFromProps,
  }) => {
    return showPostLearningGoals
      ? {
          elementPYP: _.get(post, "elementPYP"),
          curriculumProgramType: curriculumProgramType,
          showLearningGoalsEditor: false,
          showLearningGoalsPreview: true,
          propsIbPypElementRatings: _.get(post, "ibPYPElementRatings"),
          academicTerm: _.get(post, "academicTerm"),
          learningCourseIdFromProps,
        }
      : {};
  };

  const toggleMediaModal = (value, activeIndex) => {
    setShowMediaModal(value);
    setActiveIndex(activeIndex);
    if (!value) {
      if (_.get(props, "hideComments")) return;
      syncPostCommentsCache({
        postId: _.get(post, "id"),
        variables: commentCacheVariables,
        fragment: PostCommentFragment,
      });
    }
  };

  const handleActivitySelectedStudentChange = studentId => {
    if (_.isEmpty(studentId))
      setActivitySelectedStudentId(
        !_.isEmpty(_.get(props, "fromPropsActivitySelectedStudentId", ""))
          ? _.get(props, "fromPropsActivitySelectedStudentId", "")
          : _.get(
              props,
              ["filteredStudentActivities", 0, "item", "activityStudent", "id"],
              ""
            )
      );
    else setActivitySelectedStudentId(studentId);

    toggleMediaModal(true);
  };

  const onMediaClick = ({ activeIndex = 0 }) => {
    if (
      _.get(props, "isSidePaneContent", false) == true &&
      showNewTheatreMode()
    ) {
      if (_.isFunction(_.get(props, "setTheatreAttachmentIndex")))
        props?.setTheatreAttachmentIndex(activeIndex);
      else toggleMediaModal(true, activeIndex);
    } else {
      toggleMediaModal(true, activeIndex);
    }
  };

  const canUserEditPost =
    _.get(post, "createdBy.id") === currentUserId
      ? true
      : isUserAllowedToPublishPost;

  const countTextDisplayed =
    _.get(post, "likes.totalCount", 0) > 0 ||
    _.get(post, "comments.totalCount", 0) > 0 ||
    _.get(post, "seen.totalCount", 0) > 0;

  const isCommentOpen = currentCommentPostId == _.get(post, "id");

  const selectedActivityStudentIndex =
    !_.isEmpty(filteredStudentActivities) &&
    !_.isEmpty(activitySelectedStudentId)
      ? _.findIndex(
          filteredStudentActivities,
          activity =>
            _.get(activity, ["item", "activityStudent", "id"]) ===
            activitySelectedStudentId
        )
      : -1;

  const getSelectedStudentAttachments = selectedStudentActivityData => {
    let allAttachments = [];

    if (!_.isNil(selectedStudentActivityData)) {
      const attachmentsGroups = _.get(
        selectedStudentActivityData,
        "attachmentGroups",
        []
      );
      _.forEach(attachmentsGroups, group => {
        const attachments = _.get(group, "attachments", []);
        allAttachments = _.concat(allAttachments, attachments);
      });
    }
    return allAttachments;
  };

  const activityAttachments =
    selectedActivityStudentIndex !== -1
      ? getSelectedStudentAttachments(
          _.get(
            filteredStudentActivities,
            [selectedActivityStudentIndex, "item"],
            BLANK_OBJECT
          )
        )
      : [];

  const toggleDownloadBeginOverlay = () => {
    setShowDownloadBeginOverlay(true);
  };

  const handleActivitySelectedStudentAttachmentsChange = (
    setTheatreAttachmentIndex,
    attachments
  ) => {
    setTheatreAttachmentIndex?.(activeIndex);
    setAttachments(attachments);
  };

  const unreadCommentsCount =
    selectedActivityStudentIndex !== -1
      ? _.get(
          filteredStudentActivities,
          [selectedActivityStudentIndex, "item", "comments", "unreadCountV2"],
          0
        )
      : -1;

  const getTitleValue = title => {
    return !(_.isEqual(title, "null") || _.isEqual(title, "undefined"))
      ? title
      : "";
  };

  const textMoreButtonProps = {
    dsVersion: "2.0",
    variant: "progressive",
    type: "inline",
  };

  const smallCard = () => {
    const { isPrivate, isHiddenFromStudents } = post;
    const studentsArray = _.get(post, "students.edges", BLANK_ARRAY);

    const closeLikeSeenModal = e => {
      e?.stopPropagation();
      closeSeenLikeModal();
    };

    const closeSharingModal = e => {
      e?.stopPropagation();
      setSharingModalOpen(false);
    };

    const onPostActionClickV2 = isStudentFeedSmallCard
      ? params => {
          const {
            item,
            onPostActionClick,
            isSidePaneContent,
            staffEditAccess = true,
            filteredStudentActivities,
          } = props;
          if (
            !isSidePaneContent &&
            _.size(filteredStudentActivities) > 1 &&
            _.get(params, "action", "") === "LIKE"
          ) {
            // if multiple students are tagged in activity post, then like action should open theatre mode instead of like operation
            if (
              _.get(params, "action", "") === "LIKE" &&
              showNewTheatreMode()
            ) {
              toggleMediaModal(true, activeIndex);
              return;
            }
            onCardClick();
            return;
          }

          const selectedActivityStudentIndex =
            !_.isEmpty(filteredStudentActivities) &&
            !_.isEmpty(activitySelectedStudentId)
              ? _.findIndex(
                  filteredStudentActivities,
                  activity =>
                    _.get(activity, ["item", "activityStudent", "id"]) ===
                    activitySelectedStudentId
                )
              : -1;

          const activityId =
            selectedActivityStudentIndex !== -1
              ? _.get(
                  filteredStudentActivities,
                  [selectedActivityStudentIndex, "item", "id"],
                  ""
                )
              : "";
          const activityType =
            selectedActivityStudentIndex !== -1
              ? _.get(
                  filteredStudentActivities,
                  [selectedActivityStudentIndex, "itemType"],
                  ""
                )
              : "";

          onPostActionClick({
            ...params,
            item: post,
            staffEditAccess,
            activityId,
            activityType,
          });

          if (params?.action === "COMMENT") {
            if (!isSidePaneContent && showNewTheatreMode()) {
              _.size(filteredStudentActivities)
                ? toggleMediaModal(true, activeIndex)
                : setShowTheatreView(true);
            }
            if (!isSidePaneContent) {
              onCardClick();
              return;
            }
            setShowCommentBox(true);
            setTimeout(() => {
              if (commentBoxRef && commentBoxRef?.current) {
                commentBoxRef?.current?.focus();
              }
            });
          }
        }
      : onPostActionClick;

    const onPostClick = (post, action) => () =>
      onPostActionClickV2({
        id: _.get(post, "id"),
        action,
      });

    const onShowCommentsPane = post => e => {
      onPostActionClickV2({
        id: _.get(post, "id"),
        action: "COMMENT",
      });
      if (!isSidePaneContent) {
        onCardClick(e);
        return;
      }
    };

    const useTopHeaderV2 =
      isUpdatedSmallCard &&
      ((getIsEnableFamilyConsolidatedPortfolio() &&
        _.includes(window.location.href, "/family-portfolio-summary")) ||
        (showAcademicYearFilterProfilePortfolio() &&
          _.includes(window.location.href, "/studentFeed")));

    const showPostCreationDate =
      getIsEnableFamilyConsolidatedPortfolio() &&
      (_.includes(window.location.href, "/family-portfolio-summary") ||
        _.includes(window.location.href, "/studentFeed"));

    let studentObject = studentData;
    if (showPostCreationDate) {
      if (userType === "parent") {
        studentObject = _.get(
          _.find(studentsArray, ({ node }) => node.id === studentId),
          "node"
        );
      } else {
        studentObject = _.get(_.first(studentsArray), "node");
      }
    }

    const isStudentCreatedPost =
      _.get(postCreator, "id") === studentId &&
      _.get(postCreator, "type") === "student";

    const isNote = _.first(_.get(post, "attachments", []))?.type == "NOTE";

    return (
      <div
        ref={postCardRef}
        className={classNames(classes.smallCardContainer, {
          [classes.smallCardContainerV2]: isUpdatedSmallCard,
        })}
        style={cardContainerStyle}
        id={postId}
        data-test-id={`${testId}-${postId}`}
        tabIndex={0}
      >
        <div
          className={classNames(classes.smallCardHeader, {
            [classes.smallCardHeaderV2]: isUpdatedSmallCard,
            [classes.smallCardHeaderWithTopMargin]: useTopHeaderV2,
          })}
        >
          {/* Profile */}
          <AvatarGroup
            shape={isStudentFeedSmallCard ? "square" : circleShapeProp}
            size={isUpdatedSmallCard ? "x-small" : "small"}
            dsVersion={isUpdatedSmallCard ? "2.0" : "1.0"}
          >
            <Avatar
              id={_.get(postCreator, "id", "")}
              name={postCreatorName}
              src={_.get(postCreator, "profileImage", "")}
              dsVersion={isUpdatedSmallCard ? "2.0" : "1.0"}
              size={isUpdatedSmallCard ? "x-small" : "small"}
              shape={isStudentFeedSmallCard ? squareShapeProp : circleShapeProp}
            />
            {!_.isEmpty(studentObject) &&
            !isStudentCreatedPost &&
            (showPostCreationDate ? !isStudentOwnResponse : true) ? (
              <Avatar
                id={_.get(studentObject, "id")}
                name={getFormattedUserName({ user: studentObject })}
                src={_.get(studentObject, "profileImage", null)}
                dsVersion={isUpdatedSmallCard ? "2.0" : "1.0"}
                size={isUpdatedSmallCard ? "x-small" : "small"}
                shape={
                  isStudentFeedSmallCard ? squareShapeProp : circleShapeProp
                }
              />
            ) : null}
          </AvatarGroup>
          <div className={classes.titleDateContainer}>
            <div className={isUpdatedSmallCard ? "text-label" : "text-label-3"}>
              {customUserText}
            </div>

            {sharedAvatarPopoverIsOpen && (
              <SharedAvatarListPopover
                setActiveUnitPlanId={onAvatarPopoverClose}
                nodeRef={customUserTextRef?.current}
                popOverData={getFormattedPopoverData(studentsArray)}
                isData={true}
                isLoading={false}
              />
            )}

            {showPostCreationDate ? (
              <div
                className={classNames({
                  ["text-body-s"]: true,
                  [classes.sinceDateText]: true,
                })}
              >
                {sinceDateText}
              </div>
            ) : null}
          </div>
        </div>

        <div
          className={classes.cardBody}
          onClick={onCardClick}
          data-test-id={`${testId}-${postId}-card`}
        >
          {/* Post caption */}
          {!isStudentFeedSmallCard &&
            !_.isEmpty(_.get(post, "title", "")) &&
            _.get(post, "title", "") !== "null" && (
              <div className={postCaptionTextClass}>
                {showTranslation ? translatedText : _.get(post, "title", "")}
              </div>
            )}
          {isStudentFeedSmallCard && !_.isEmpty(_.get(post, "title", "")) && (
            <div
              className={
                isPortfolioRevampAndIsJournalRoute() ||
                isStudentFeedSmallCard ||
                isDSV2
                  ? isStudentFeedSmallCard
                    ? postCaptionClassV2
                    : postCaptionClass
                  : classes.postCaptionText
              }
            >
              <TextMoreLessV2
                value={
                  showTranslatedText
                    ? getTitleValue(titleText)
                    : getTitleValue(_.get(post, "title", ""))
                }
                minHeight={24 * (isRightPaneCard ? 2 : 5)} // line height is 2.4rem and we want to keep 5 lines visible, so 24*(visible lines)
                lineClamp={isRightPaneCard ? 5 : 7}
                testId="journal-feed-postcard-title"
                buttonProps={textMoreButtonProps}
              />
            </div>
          )}

          {/* Attachments section */}
          {!_.isEmpty(assesmentData) ? (
            studentResponseV2({ cardType: "small" })
          ) : (
            <MultipleAttachmentsSlider
              attachments={_.get(post, "attachments", BLANK_ARRAY)}
              mode={"view"}
              showDeleteIcon={false}
              slidesToShow={slidesToManage}
              slidesToScroll={slidesToManage}
              listContainerStyles={
                _.get(post, "attachments.length", 0) > 0
                  ? {
                      ...style.listContainerStyles,
                      marginTop: isUpdatedSmallCard ? "0px" : "16px",
                    } // Used willChange for safari overflow & flickering issue
                  : {}
              }
              responsiveSettings={
                isAttachmentsSliderResponsive ? responsiveSettings : []
              }
              // props useful for theatre mode and its side pane
              post={post}
              canCreateComment={props?.canPublishComment}
              postViewMode={"view"}
              onPostActionClick={onPostActionClickV2}
              showAttachmentAsMediaCard={showAttachmentAsMediaCard}
              theatreActiveAttachmentId={theatreActiveAttachmentId}
              setTheatreAttachmentIndex={setTheatreAttachmentIndex}
              isSidePaneContent={isSidePaneContent}
              showTheatreViewByParent={showTheatreView}
              setShowTheatreViewInParent={setShowTheatreView}
              setRefetchComment={setRefetchComment}
              cardType={"small"}
              showFullWidthSingleAttachment={true}
              canDownloadMedia={canDownloadMedia}
              postIdFromParent={
                _.get(props, "sourceType") == "PUBLIC_URL"
                  ? _.get(props, "params.postId")
                  : undefined
              }
              hideComments={hideComments}
              hideLike={hideLike}
              hideViews={hideViews}
              canEditOrDelete={canEditOrDelete}
              hideMoveToDraftOption={hideMoveToDraftOption}
              defaultAccodianExpanded={defaultAccodianExpanded}
              canAddComments={canAddComments}
              onCloseClick={onCloseClick}
              extensionTagSize={extensionTagSize}
              isUpdatedSmallCard={isUpdatedSmallCard}
              postRatedLearningGoalsDetails={postRatedLearningGoalsDetails({
                post,
                curriculumProgramType,
                showPostLearningGoals,
                learningCourseIdFromProps: _.get(
                  _.first(_.get(post, "course.learningCourse", "")),
                  "id",
                  ""
                ),
              })}
              taggedStudents={_.get(post, "students.edges", BLANK_ARRAY)}
              isNote={isNote}
            />
          )}

          {!_.isEmpty(filteredStudentActivities) && isStudentFeedSmallCard ? (
            <div style={style.activityContainerStyle}>
              <StudentActivities
                studentActivities={filteredStudentActivities}
                isSidePaneContent={isSidePaneContent}
                handleActivitySelectedStudentChange={
                  handleActivitySelectedStudentChange
                }
                onMediaClick={onMediaClick}
                carouselWrapperStyle={
                  isPortfolioParityEnabledAndIsJournalRoute()
                    ? style.carouselWrapperStyle
                    : BLANK_OBJECT
                }
                isStudentFeedSmallCard={isStudentFeedSmallCard}
                showAttachmentCounterTag={isPortfolioParityEnabledAndIsJournalRoute()}
              />
            </div>
          ) : null}
          {(showLikesModal || showViewsModal) && isStudentFeedSmallCard && (
            <PostSeenLikeModal
              isModalOpen={showLikesModal || showViewsModal}
              closeSeenLikeModal={closeLikeSeenModal}
              postId={_.get(post, "id")}
              showLikes={showLikesModal}
              showViews={showViewsModal}
              t={t}
            />
          )}
          {isSharingModalOpen && isStudentFeedSmallCard && (
            <PostSharedWithModal
              isModalOpen={isSharingModalOpen}
              closeSharingModal={closeSharingModal}
              post={post}
              taggedStudents={getStudents(_.get(post, "students.edges", []))}
              isPrivate={isPrivate}
              isHiddenFromStudents={isHiddenFromStudents}
              t={t}
            />
          )}

          {isStudentFeedSmallCard ? (
            <ModelContent
              attachments={
                !_.isEmpty(filteredStudentActivities) &&
                !_.isEmpty(activitySelectedStudentId)
                  ? _.get(props, "openedFromNotification", false)
                    ? activityAttachments
                    : attachments
                  : attachments
              }
              isStudentResponse={!_.isEmpty(assesmentData)}
              toggleMediaModal={toggleMediaModal}
              showMediaModal={showMediaModal}
              activeIndex={activeIndex}
              toggleDownloadBeginOverlay={toggleDownloadBeginOverlay}
              post={post}
              curriculumProgramType={props?.curriculumProgramType}
              t={t}
              canCreateComment={props?.canPublishComment}
              postViewMode={
                props?.isRemovedCourseForLoggedInUser ||
                isArchivedClass ||
                !props?.isCurrentAcademicYearSelected
                  ? "view"
                  : "edit"
              } // disabling liking post and comment actions in view mode
              updatePostStatus={props?.updatePostStatus}
              onPostActionClick={onPostActionClickV2}
              onPostSidePaneCloseClick={onCloseClick}
              fromPropsActivitySelectedStudentId={activitySelectedStudentId}
              fromPropsHandleActivitySelectedStudentChange={
                handleActivitySelectedStudentChange
              }
              fromPropsHandleActivitySelectedStudentAttachmentsChange={
                handleActivitySelectedStudentAttachmentsChange
              }
              staffEditAccess={staffEditAccess}
              hideLike={hideLike}
              hideViews={hideViews}
              hideComments={hideComments}
              hideLearninGoals={hideLearninGoals}
              hideTaggedStudents={hideTaggedStudents}
              hideUnitDetails={hideUnitDetails}
              showTaggedFolders={showTaggedFolders}
              taggedStudents={_.get(post, "students.edges", [])}
              showPostLearningGoals={_.get(
                props,
                "showPostLearningGoals",
                true
              )}
              canDownloadMedia={canDownloadMedia}
              sourceType={_.get(props, "sourceType", BLANK_STRING)}
              paramPostId={_.get(props, "params.postId", BLANK_STRING)}
              isViewFromPostPage={isViewFromPostPage}
              openedFromNotification={_.get(
                props,
                "openedFromNotification",
                false
              )}
              canEditOrDelete={canEditOrDelete}
              canAddComments={isProjectPostCard ? canAddComments : true} // This will determine whether to show comment box or not in theatre mode post details section
              hasManageAccess={hasManageAccessForStudentPortfolio}
              isActivityPost={
                !_.isEmpty(filteredStudentActivities) &&
                !_.isEqual(userType, "staff")
              }
            />
          ) : null}

          {/* Tags for journal post / Tagged outcomes for porject */}
          {isProjectPostCard ? (
            <TaggedElementPYP
              elementPYP={_.get(post, "elementPYP", BLANK_ARRAY)}
              otherTags={otherTags}
              hideElementPYP={hideElementPYP}
              toggleTagModal={toggleTagModal}
              t={t}
              goToRelativeRoute={goToRelativeRoute}
              maxOtherTagsToShow={maxOtherTagsToShow}
              maxWidthForTag={maxWidthForTag}
              customTagContainerStyle={customTagContainerStyle}
              isDSV2={isDSV2}
              isUpdatedSmallCard={isUpdatedSmallCard}
            />
          ) : (
            <TaggedFolders
              folders={tags}
              tagSize={"small"}
              containerStyle={tagFolderContainerSmallCardStyle}
              singleTagContainerStyle={singleTagContainerStyle}
            />
          )}
        </div>
        {isPortfolioParityEnabled() &&
        !isProjectPostCard &&
        isStudentFeedSmallCard ? (
          <div className={cardFooterClass}>
            <div className={classes.cardFooterV2}>
              <div className={classes.footerButtonLeftContainer}>
                {!(
                  (_.get(post, "state", "") == "DRAFT" &&
                    userType == "student") ||
                  (_.get(postFilters, "state") === "IN_APPROVAL_STAFF" &&
                    isPortfolioReviewSetupEnabled() &&
                    !isUserAllowedToPublishPost)
                ) && hasManageAccessForStudentPortfolio ? (
                  <FooterButtons
                    staffEditAccess={staffEditAccess}
                    userType={userType}
                    id={_.get(post, "id")}
                    showLikeButton={_.isNil(hideLike) ? true : !hideLike}
                    likes={
                      selectedActivityStudentIndex !== -1
                        ? _.size(filteredStudentActivities) > 1 &&
                          !isSidePaneContent
                          ? null
                          : _.get(
                              filteredStudentActivities,
                              [selectedActivityStudentIndex, "item", "likes"],
                              {}
                            )
                        : _.get(post, "likes", BLANK_OBJECT)
                    }
                    showCommentButton={
                      _.isNil(hideComments) ? true : !hideComments
                    }
                    comments={
                      selectedActivityStudentIndex !== -1
                        ? _.get(
                            filteredStudentActivities,
                            [selectedActivityStudentIndex, "item", "comments"],
                            BLANK_OBJECT
                          )
                        : _.get(post, "comments", BLANK_OBJECT)
                    }
                    seenCount={_.get(post, "seen.totalCount", 0)}
                    state={_.get(post, "state")}
                    userId={currentUserId}
                    isCommentOpen={isCommentOpen}
                    onPostActionClick={onPostActionClickV2}
                    canEditOrDelete={canEditOrDelete}
                    createdByType={_.get(postCreator, "type")}
                    t={t}
                    createdByName={_.get(postCreator, "firstName")}
                    isArchivedClass={isArchivedClass}
                    isAddLEToJournal={_.isEqual(
                      _.get(assesmentData, "itemType", ""),
                      "STUDENT_ASSIGNMENT"
                    )}
                    isSidePaneContent={isSidePaneContent}
                    showTranslationButton={
                      hasTranslationPermission() &&
                      _.get(post, "titleTranslationItem.showTranslate", false)
                    }
                    showTranslatedText={showTranslatedText}
                    toggleTranslatedText={toggleTranslatedText}
                    isViewFromPostPage={isViewFromPostPage}
                    showLikeCount={true}
                    showCommentCount={true}
                    countTextDisplayed={countTextDisplayed}
                    isPostTypeActivity={!_.isEmpty(filteredStudentActivities)}
                    showDesignV2={true}
                    isUserAllowedToPublishPost={isUserAllowedToPublishPost}
                    isPostCtaDisabled={
                      isPostCtaDisabled ||
                      (isPortfolioReviewSetupEnabled() && !canUserEditPost)
                    }
                    canUserEditPost={canUserEditPost}
                    setTitleText={setTitleText}
                    hasManageAccessForStudentPortfolio={
                      hasManageAccessForStudentPortfolio
                    }
                  />
                ) : null}
                {_.get(post, "state", "") == "DRAFT" &&
                  userType == "student" &&
                  (isApprovalRequiredForStudentPosts ? (
                    <Button
                      variant="progressive"
                      size="large"
                      onClick={onPostClick(post, "IN_APPROVAL")}
                      disabled={isArchivedClass || isStudentArchived}
                      testId="journal-feed-postcard-sendforapproval"
                    >
                      <span style={style.inApprovalButtonStyle}>
                        <PublishOutlined variant="on" />
                      </span>
                      <div className={classes.approveText}>
                        {t("journal:send_for_approval")}
                      </div>
                    </Button>
                  ) : (
                    <Button
                      variant="progressive"
                      size="large"
                      onClick={onPostClick(post, "PUBLISH")}
                      disabled={isArchivedClass || isStudentArchived}
                      testId="journal-feed-postcard-publish"
                    >
                      <span style={style.inApprovalButtonStyle}>
                        <PublishOutlined variant="on" />
                      </span>
                      <div className={classes.approveText}>
                        {t("common:publish")}
                      </div>
                    </Button>
                  ))}
              </div>
              {/* <div className={classes.footerButtonRightContainer}>
                {/* See translation button */}
              {/* {showTranslationButton && (
                  <Button
                    variant={"inline"}
                    onClick={() => setShowTranslation(!showTranslation)}
                  >
                    <span style={{ fontSize: "1.4rem" }}>
                      {t(
                        showTranslation
                          ? "common:see_original"
                          : "common:see_translation"
                      )}
                    </span>
                  </Button>
                )} */}
              {/* </div> */}
            </div>
            {_.get(post, "state", "") == "PUBLISHED" && !isProjectPostCard ? (
              <FooterText
                showLike={true}
                likesCount={_.get(post, "likes.totalCount", 0)}
                viewsCount={_.get(post, "seen.totalCount", 0)}
                likedByName={likedByFooterTextName}
                t={t}
                showViews={userType === "staff"}
                userType={userType}
                toggleLikeModal={toggleLikesModal}
                toggleViewsModal={toggleViewsModal}
                showComment={_.isNil(hideComments) ? true : !hideComments}
                commentsCount={_.get(post, "comments.totalCount", 0)}
                showCommentsPane={onShowCommentsPane(post)}
                showNewDesign={
                  (isJournalRoute || isStudentFeedSmallCard) &&
                  isPortfolioParityEnabled()
                }
                showNewDesignV2={
                  (isJournalRoute || isStudentFeedSmallCard) &&
                  isPortfolioFilterRevamp()
                }
              />
            ) : null}
            {isStudentFeedSmallCard &&
            props?.isCommentEnabled &&
            !isRightPaneCard &&
            !(
              getIsEnableFamilyConsolidatedPortfolio() &&
              _.includes(window.location.href, "/family-portfolio-summary")
            ) &&
            (isJournalRoute ||
            isStudentFeedRoute ||
            isPortfolioReviewSetupEnabledAndIsReviewRoute()
              ? isPortfolioParityEnabled()
                ? isPortfolioReviewSetupEnabledAndIsReviewRoute()
                  ? _.get(post, "state", "") !== "IN_APPROVAL"
                  : isSidePaneContent
                : true
              : true) ? (
              <div
                className={
                  isProjectPostCard
                    ? classes.commentsContainerV2
                    : classes.commentsContainer
                }
              >
                <CardCommentsV2
                  parentId={_.get(post, "id")}
                  parentType={"POST"}
                  showCommentBox={showCommentBox && props?.isCommentEnabled}
                  canPublishComment={props?.canPublishComment}
                  commentBoxRef={commentBoxRef}
                  canComment={props?.isCommentEnabled && canAddComments}
                  canDelete={canAddComments}
                  showViewAllComments={!isSidePaneContent}
                  refetchComment={refetchComment}
                  setRefetchComment={setRefetchComment}
                  showCommentBadge={!showPostBadge && showBadge} // Adding this because if post is unread we don't show comment badges
                  commentsFromProps={commentsFromProps}
                  isJournal={isJournalRoute || isStudentFeedRoute}
                  totalCount={_.get(
                    post,
                    "latestComments.totalCount",
                    _.get(post, "comments.totalCount", 0)
                  )}
                  cacheVariables={{ first: 1 }}
                  postFragment={postFragment}
                  showViewCommentButtonText={showViewCommentButtonText}
                  showViewCommentButtonAtTop={showViewCommentButtonAtTop}
                  unreadCount={unreadCommentsCount}
                  hasManageAccessForStudentPortfolio={
                    isSidePaneContent
                      ? hasManageAccessForStudentPortfolioFromProps
                      : hasManageAccessForStudentPortfolio
                  }
                  isProjectPostCard={isProjectPostCard}
                />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  };

  if (
    shouldHidePostCardToFamily({
      assessment: assessmentItem,
      curriculumProgramId: currentCurriculumProgramId,
      userType,
    })
  )
    return null;
  if (cardType === "small") {
    return smallCard();
  } else {
    const { isPrivate, isHiddenFromStudents } = post;
    const isEditable =
      userType == "staff" || currentUserId == _.get(postCreator, "id");

    const onEditPostClick = () => {
      const assesmentData = _.find(
        items,
        item => _.get(item, "itemType", "") === "STUDENT_ASSIGNMENT"
      );
      const isAddLEToJournal =
        !_.isNil(assesmentData) && !_.isEmpty(assesmentData);

      onPostActionClick({
        id: _.get(post, "id"),
        action: "POST_EDIT",
        isAddLEToJournal: isAddLEToJournal,
      });
      if (_.isFunction(onCloseClick)) onCloseClick();
    };

    const isPostUnderApproval =
      _.isEqual(_.get(post, "state"), "IN_APPROVAL") &&
      (userType === "student" ||
        (isPortfolioReviewSetupEnabledAndIsJournalRoute() &&
          userType === "staff" &&
          !isUserAllowedToPublishPost &&
          _.get(post, "createdBy.type") !== "student"));
    const isPostRejected =
      (_.isEqual(_.get(post, "state"), "REJECTED") && userType === "student") ||
      (isPortfolioReviewSetupEnabledAndIsJournalRoute() &&
        _.get(postFilters, "state") === "IN_APPROVAL_STAFF" &&
        userType === "staff" &&
        _.isEqual(_.get(post, "state"), "REJECTED"));
    const isPostApproveRejectEnabled = _.isEqual(
      _.get(post, "state"),
      "REJECTED"
    );
    const rejectedBy = _.get(post, "approveOrRejectBy", {});
    const studentPostStatusContainer = classNames({
      [classes.postStatusBannerContainer]: true && !isPortfolioParityEnabled(),
      [classes.postStatusBannerContainerV2]: isPortfolioParityEnabled(),
      [classes.approvalContainer]:
        isPostUnderApproval && !isPortfolioParityEnabled(),
      [classes.approvalContainerV2]:
        isPostUnderApproval && isPortfolioParityEnabled(),
      [classes.rejectedContainer]:
        isPostRejected && !isPortfolioParityEnabled(),
      [classes.rejectedContainerV2]:
        isPostRejected && isPortfolioParityEnabled(),
    });
    const rejectComment = _.get(post, "rejectComment", "");

    const isNote = _.first(_.get(post, "attachments", []))?.type == "NOTE";

    const selectedActivityStudentIndex =
      !_.isEmpty(filteredStudentActivities) &&
      !_.isEmpty(activitySelectedStudentId)
        ? _.findIndex(
            filteredStudentActivities,
            activity =>
              _.get(activity, ["item", "activityStudent", "id"]) ===
              activitySelectedStudentId
          )
        : -1;

    const isCommentOpen = currentCommentPostId == _.get(post, "id");

    const countTextDisplayed =
      _.get(post, "likes.totalCount", 0) > 0 ||
      _.get(post, "comments.totalCount", 0) > 0 ||
      _.get(post, "seen.totalCount", 0) > 0;

    const onPostActionClick = params => {
      const {
        onPostActionClick,
        isSidePaneContent,
        staffEditAccess = true,
        filteredStudentActivities,
      } = props;
      if (
        !isSidePaneContent &&
        _.size(filteredStudentActivities) > 1 &&
        _.get(params, "action", "") === "LIKE"
      ) {
        // if multiple students are tagged in activity post, then like action should open theatre mode instead of like operation
        if (_.get(params, "action", "") === "LIKE" && showNewTheatreMode()) {
          toggleMediaModal(true, activeIndex);
          return;
        }
        onCardClick();
        return;
      }

      const selectedActivityStudentIndex =
        !_.isEmpty(filteredStudentActivities) &&
        !_.isEmpty(activitySelectedStudentId)
          ? _.findIndex(
              filteredStudentActivities,
              activity =>
                _.get(activity, ["item", "activityStudent", "id"]) ===
                activitySelectedStudentId
            )
          : -1;

      const activityId =
        selectedActivityStudentIndex !== -1
          ? _.get(
              filteredStudentActivities,
              [selectedActivityStudentIndex, "item", "id"],
              ""
            )
          : "";
      const activityType =
        selectedActivityStudentIndex !== -1
          ? _.get(
              filteredStudentActivities,
              [selectedActivityStudentIndex, "itemType"],
              ""
            )
          : "";

      onPostActionClick({
        ...params,
        item: post,
        staffEditAccess,
        activityId,
        activityType,
      });

      if (params?.action === "COMMENT") {
        if (!isSidePaneContent && showNewTheatreMode()) {
          _.size(filteredStudentActivities)
            ? toggleMediaModal(true, activeIndex)
            : setShowTheatreView(true);
        }
        if (!isSidePaneContent) {
          onCardClick();
          return;
        }
        setShowCommentBox(true);
        setTimeout(() => {
          if (commentBoxRef && commentBoxRef?.current) {
            commentBoxRef?.current?.focus();
          }
        });
      }
    };

    const audioFileDownload = attachment => {
      const { downloadFromUrl, removeProgressElement } = props;
      let name = _.get(attachment, "name", "");
      if (_.isEmpty(name)) {
        name = "toddle_audio_" + moment().format("DD-MM-YY_h_mm");
      }

      const id = "Toddle_audio_#123";

      downloadFromUrl({
        name: name,
        attachment: attachment,
        shouldAskForSave: true,
        fileUploadId: id,
      }).then(() => {
        removeProgressElement({ id });
      });
    };

    const commentsCount =
      selectedActivityStudentIndex !== -1
        ? _.get(
            filteredStudentActivities,
            [selectedActivityStudentIndex, "item", "comments", "totalCount"],
            0
          )
        : _.get(post, "comments.totalCount", 0);

    const canUserEditPost =
      _.get(post, "createdBy.id") === currentUserId
        ? true
        : isUserAllowedToPublishPost;

    const cardClasses = classNames({
      [classes.cardContainer]: !isPortfolioParityEnabled(),
      [classes.cardContainerV2]: isPortfolioParityEnabled(),
      [classes.cardContainerV3]: isDSV2,
    });

    const userContainerClasses = classNames({
      [classes.userContainer]: true,
      [classes.userContainerV2]: isDSV2,
    });

    const dotClasses = classNames({
      [classes.dot]: true,
      [classes.dotV2]: isDSV2,
    });

    const isNewNoteUi = isNewNotesUi();
    const noteStyle = isNewNoteUi
      ? style.newNoteContainerStyleV2
      : style.noteContainerStyleV2;

    const noteStyle2 = isNewNoteUi
      ? style.noteContainerStyleNew
      : style.noteContainerStyle;

    const isWorkBook = _.first(_.get(post, "attachments"))?.type === "WORKBOOK";
    return (
      <div
        ref={postCardRef}
        className={cardClasses}
        style={
          isPortfolioRevampAndIsJournalRoute()
            ? {
                ...style.cardContainerV3Style,
                ...cardContainerStyle,
                ...(_.get(postFilters, "state") === "IN_APPROVAL_STAFF" ||
                _.get(post, "state") === "IN_APPROVAL"
                  ? style.postCardTopMargin
                  : {}),
              }
            : cardContainerStyle
        }
        id={postId}
        data-test-id="journal-feed-postcard"
      >
        {isPostUnderApproval || isPostRejected ? (
          <div
            data-test-id="journal-feed-postcard-approvalbanner"
            className={studentPostStatusContainer}
            style={
              isSidePaneContent
                ? { marginTop: "-16px" }
                : isPortfolioRevampAndIsJournalRoute()
                ? style.postStatusContainerStyle
                : {}
            }
          >
            {isPortfolioParityEnabled() && isPostUnderApproval ? (
              <ClockFilled variant={"warning"} />
            ) : null}
            {isPortfolioParityEnabled() && isPostRejected ? (
              <WarningTriangleFilled variant={"warning"} />
            ) : null}
            {isPostUnderApproval
              ? _.get(postCreator, "type") === "staff"
                ? t("journal:waiting_approval")
                : t("journal:waiting_teacher_approval")
              : ""}
            {isPostRejected
              ? t("journal:teacher_returned_for_review", {
                  label: getFormattedUserName({ user: rejectedBy }),
                })
              : ""}
          </div>
        ) : null}
        {!_.isEmpty(rejectComment) &&
          isPostApproveRejectEnabled &&
          (isPortfolioParityEnabled() ? (
            <div className={classes.rejectCommentContainerV2}>
              <span
                className={classes.rejectCommentTextV2}
                data-test-id="journal-feed-postcard-rejectcomment"
              >
                {rejectComment}
              </span>
            </div>
          ) : (
            <div className={classes.rejectCommentContainer}>
              <div className={classes.rejectCommentIcon}>
                <CommentRemarkOutlined />
              </div>
              <span
                className={classes.rejectCommentText}
                data-test-id="journal-feed-postcard-rejectcomment"
              >
                {rejectComment}
              </span>
            </div>
          ))}
        {!isViewFromPostPage && showCloseBtn && (
          <div style={{ margin: "8px 0", alignSelf: "flex-end" }}>
            <IconButton
              icon={<CloseOutlined />}
              onClick={_.isFunction(onCloseClick) ? onCloseClick : () => {}}
              variant="plain"
              size={"x-small"}
              testId="journal-feed-postcard-close"
            />
          </div>
        )}
        <EditDateModal
          editDateDetails={editDateDetails}
          setEditDateDetails={setEditDateDetails}
          updatePostDate={updatePostDate}
          post={post}
          isProjectPost={isProjectPostCard}
          t={t}
        />
        <div
          className={classNames({
            [classes.cardHeader]: true,
            [classes.sidePaneCardHeader]: isSidePaneContent,
            [classes.cardHeaderV2]: isDSV2,
          })}
          style={cardHeaderStyle}
        >
          <div className={userContainerClasses}>
            {showPostBadge ? <div className={dotClasses} /> : null}
            {/* Profile */}
            <SingleUserProfile
              username={postCreatorName}
              id={_.get(postCreator, "id", "")}
              profileImageSrc={_.get(postCreator, "profileImage", "")}
              avatarSize={isRightPaneCard ? "small" : "medium"}
              isRightPaneCard={isRightPaneCard}
              subText={sinceDateText}
              customUserText={customUserText}
              usernameStyle={
                !isPortfolioParityEnabled() ? style.usernameStyle : BLANK_OBJECT
              }
              showDualCascadedProfile={
                isPortfolioParityEnabled() &&
                _.get(postCreator, "id", "") !==
                  getStudentTaggedInformation()?.id &&
                !_.isEmpty(getStudentTaggedInformation())
                  ? true
                  : isStudentResponse && !isStudentOwnResponse
              }
              user2={
                (isPortfolioParityEnabled() && _.isEmpty(studentData)) ||
                isStudentOwnResponse
                  ? getStudentTaggedInformation()
                  : studentData
              }
              isPrivate={isPrivate}
              isHiddenFromStudents={isHiddenFromStudents}
              showSharedWith={
                userType === "staff" &&
                isPortfolioParityEnabled() &&
                !isProjectPostCard &&
                showShareWith
              }
              t={t}
              subtextStyle={{
                alignItems: isPortfolioParityEnabled() ? "center" : "",
              }}
              showSharingModal={setSharingModalOpen}
              defaultStudentNameOrderPreference={
                defaultStudentNameOrderPreference
              }
              courseTitle={courseTitle}
              shape={isPortfolioRevampAndIsJournalRoute() ? "square" : "circle"}
              showUserNameClassV2={isPortfolioRevampAndIsJournalRoute()}
              cascadeProfileStyle={
                isPortfolioRevampAndIsJournalRoute()
                  ? style.cascadeProfileStyle
                  : BLANK_OBJECT
              }
            />
          </div>

          {/* Draft status tag */}
          {_.isEqual(_.get(post, "state"), "DRAFT") &&
            !isPortfolioParityEnabled() && (
              <div style={{ margin: "0 8px 0 auto" }}>
                <Tag size={"small"} color={"yellow"}>
                  {_.capitalize(_.get(post, "state"), "DRAFT")}
                </Tag>
              </div>
            )}

          {customTagComponent}
          {/* Options dropdown */}
          {canEditOrDelete &&
            cardType !== "small" &&
            !isViewFromPostPage &&
            (hasManageAccess || isProjectPostCard) && (
              <DropDown
                userType={userType}
                id={_.get(post, "id")}
                createdAt={_.get(post, "createdAt")}
                onPostActionClick={onPostActionClick}
                createdByType={_.get(postCreator, "type")}
                isArchivedClass={isArchivedClass}
                isAddLEToJournal={
                  !_.isNil(assesmentData) && !_.isEmpty(assesmentData)
                } //useful when LE responce is added: _.isEqual(itemType, "STUDENT_ASSIGNMENT")}
                postState={_.get(post, "state")}
                showNewDropdown={true}
                showBackdateOption={
                  isPortfolioParityEnabledAndIsJournalRoute() &&
                  !isProjectPostCard
                    ? false
                    : userType == "staff" && _.get(post, "state") != "SCHEDULED"
                }
                studentActivityType={
                  !_.isEmpty(filteredStudentActivities)
                    ? _.get(
                        _.first(filteredStudentActivities),
                        "item.activityType"
                      )
                    : undefined
                }
                onEditDateClick={onEditDateClick}
                onCloseClick={onCloseClick}
                isSidePaneContent={isSidePaneContent}
                hideDraftOption={hideMoveToDraftOption}
                containerStyle={
                  showPortfolioParityCard
                    ? style.dropDownContainerStyle
                    : BLANK_OBJECT
                }
                isProjectPost={isProjectPostCard}
              />
            )}
          {/* edit post button */}
          {isSidePaneContent &&
          isEditable &&
          cardType === "small" &&
          !isViewFromPostPage ? (
            <IconButton
              icon={<PencilOutlined />}
              onClick={onEditPostClick}
              variant="plain"
              size="medium"
            />
          ) : null}
        </div>
        <div className={classes.cardBody} onClick={onCardClick}>
          {/* Post caption */}
          {!_.isEmpty(_.get(post, "title", "")) && (
            <div
              className={
                isPortfolioRevampAndIsJournalRoute() || isDSV2
                  ? postCaptionClass
                  : classes.postCaptionText
              }
            >
              <TextMoreLessV2
                value={
                  showTranslatedText
                    ? getTitleValue(titleText)
                    : getTitleValue(_.get(post, "title", ""))
                }
                minHeight={24 * (isRightPaneCard ? 2 : 5)} // line height is 2.4rem and we want to keep 5 lines visible, so 24*(visible lines)
                lineClamp={isRightPaneCard ? 5 : 7}
                testId="journal-feed-postcard-title"
                buttonProps={textMoreButtonProps}
              />
            </div>
          )}

          {showPortfolioParityCard &&
            _.map(fetchAudioAttachment(), attachment => (
              <div className={classes.audioCard}>
                <AudioWaveformPlayer
                  attachment={attachment}
                  audioLoaded={_.noop}
                />
                <span
                  style={{
                    alignSelf: "center",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <IconButton
                    icon={<DownloadOutlined />}
                    variant="plain"
                    size="small"
                    onClick={() => {
                      audioFileDownload(attachment);
                    }}
                  />
                </span>
              </div>
            ))}
          {!_.isEmpty(filteredStudentActivities) ? (
            <div style={{ paddingTop: "12px" }}>
              <StudentActivities
                studentActivities={filteredStudentActivities}
                isSidePaneContent={isSidePaneContent}
                handleActivitySelectedStudentChange={
                  handleActivitySelectedStudentChange
                }
                onMediaClick={onMediaClick}
                carouselWrapperStyle={
                  isPortfolioParityEnabledAndIsJournalRoute()
                    ? style.carouselWrapperStyle
                    : BLANK_OBJECT
                }
                showAttachmentCounterTag={isPortfolioParityEnabledAndIsJournalRoute()}
              />
            </div>
          ) : null}

          <ModelContent
            attachments={
              !_.isEmpty(filteredStudentActivities) &&
              !_.isEmpty(activitySelectedStudentId)
                ? _.get(props, "openedFromNotification", false)
                  ? activityAttachments
                  : attachments
                : attachments
            }
            isStudentResponse={!_.isEmpty(assesmentData)}
            toggleMediaModal={toggleMediaModal}
            showMediaModal={showMediaModal}
            activeIndex={activeIndex}
            toggleDownloadBeginOverlay={toggleDownloadBeginOverlay}
            post={post}
            curriculumProgramType={props?.curriculumProgramType}
            t={t}
            canCreateComment={props?.canPublishComment}
            postViewMode={
              props?.isRemovedCourseForLoggedInUser ||
              isArchivedClass ||
              !props?.isCurrentAcademicYearSelected
                ? "view"
                : "edit"
            } // disabling liking post and comment actions in view mode
            updatePostStatus={props?.updatePostStatus}
            onPostActionClick={onPostActionClick}
            onPostSidePaneCloseClick={onCloseClick}
            fromPropsActivitySelectedStudentId={activitySelectedStudentId}
            fromPropsHandleActivitySelectedStudentChange={
              handleActivitySelectedStudentChange
            }
            fromPropsHandleActivitySelectedStudentAttachmentsChange={
              handleActivitySelectedStudentAttachmentsChange
            }
            staffEditAccess={staffEditAccess}
            hideLike={hideLike}
            hideViews={hideViews}
            hideComments={hideComments}
            hideLearninGoals={hideLearninGoals}
            hideTaggedStudents={hideTaggedStudents}
            hideUnitDetails={hideUnitDetails}
            showTaggedFolders={showTaggedFolders}
            taggedStudents={_.get(post, "students.edges", [])}
            showPostLearningGoals={_.get(props, "showPostLearningGoals", true)}
            canDownloadMedia={canDownloadMedia}
            sourceType={_.get(props, "sourceType", BLANK_STRING)}
            paramPostId={_.get(props, "params.postId", BLANK_STRING)}
            isViewFromPostPage={isViewFromPostPage}
            openedFromNotification={_.get(
              props,
              "openedFromNotification",
              false
            )}
            canEditOrDelete={canEditOrDelete}
            canAddComments={isProjectPostCard ? canAddComments : true} // This will determine whether to show comment box or not in theatre mode post details section
            hasManageAccess={hasManageAccessForStudentPortfolio}
            isActivityPost={
              !_.isEmpty(filteredStudentActivities) &&
              !_.isEqual(userType, "staff")
            }
          />
          {/* Attachments section */}

          {!_.isEmpty(assesmentData) ? (
            studentResponseV2({
              hasManageAccess: hasManageAccessForStudentPortfolio,
            })
          ) : (
            <MultipleAttachmentsSlider
              attachments={
                showPortfolioParityCard
                  ? _.filter(
                      _.get(post, "attachments", []),
                      attachment => attachment.type !== "AUDIO"
                    )
                  : _.get(post, "attachments", [])
              }
              mode={"view"}
              showDeleteIcon={false}
              slidesToShow={slidesToManage}
              slidesToScroll={slidesToManage}
              listContainerStyles={
                _.get(post, "attachments.length", 0) > 0
                  ? {
                      marginTop: "16px",
                      ...(isSafari() ? { willChange: "transform" } : {}),
                    } // Used willChange for safari overflow & flickering issue
                  : {}
              }
              responsiveSettings={
                isAttachmentsSliderResponsive ? responsiveSettings : []
              }
              // props useful for theatre mode and its side pane
              post={post}
              canCreateComment={props?.canPublishComment}
              postViewMode={"view"}
              onPostActionClick={onPostActionClick}
              showAttachmentAsMediaCard={showAttachmentAsMediaCard}
              theatreActiveAttachmentId={theatreActiveAttachmentId}
              setTheatreAttachmentIndex={setTheatreAttachmentIndex}
              isSidePaneContent={isSidePaneContent}
              showTheatreViewByParent={showTheatreView}
              setShowTheatreViewInParent={setShowTheatreView}
              setRefetchComment={setRefetchComment}
              onCloseTheatreMode={onCloseTheatreMode}
              canDownloadMedia={canDownloadMedia}
              postIdFromParent={
                _.get(props, "sourceType") == "PUBLIC_URL"
                  ? _.get(props, "params.postId")
                  : undefined
              }
              hideComments={hideComments}
              showAttachmentsUsingScrollableCarousel={
                isPortfolioParityEnabled() && !isProjectPostCard
              }
              attachmentCardStyle={{
                ...((isPortfolioParityEnabledAndIsJournalRoute() ||
                  isPortfolioReviewSetupEnabledAndIsReviewRoute()) &&
                !isProjectPostCard
                  ? isNote
                    ? isPortfolioRevampAndIsJournalRoute()
                      ? noteStyle
                      : noteStyle2
                    : isPortfolioRevampAndIsJournalRoute()
                    ? style.attachmentContainerStyleV2(isTablet)
                    : style.attachmentContainerStyle
                  : BLANK_OBJECT),
              }}
              hideLike={hideLike}
              hideViews={hideViews}
              canEditOrDelete={canEditOrDelete}
              hideMoveToDraftOption={hideMoveToDraftOption}
              postRatedLearningGoalsDetails={postRatedLearningGoalsDetails({
                post,
                curriculumProgramType,
                showPostLearningGoals,
              })}
              taggedStudents={_.get(post, "students.edges", [])}
              noteContainerStyle={{
                ...(isNote && showPortfolioParityCard
                  ? { padding: "0px" }
                  : {}),
              }}
              isProjectPostCard={isProjectPostCard}
              canAddComments={canAddComments}
              removeAttachmentStyle={
                isPortfolioParityEnabled() &&
                !_.isEqual(cardType, "small") &&
                !isProjectPostCard
              }
              carouselWrapperStyle={
                isPortfolioParityEnabledAndIsJournalRoute()
                  ? style.carouselWrapperStyle
                  : BLANK_OBJECT
              }
              showAttachmentCounterTag={isPortfolioParityEnabledAndIsJournalRoute()}
              onCloseClick={onCloseClick}
              attachmentItemCustomClass={classes.attachmentItemContainer}
              scrollableCarouselWrapperCustomClass={
                classes.scrollableCarouselWrapperContainer
              }
              attachmentBorderRadius="8px"
              noteLinesContainerStyles={{ borderRadius: "8px" }}
              hasManageAccess={hasManageAccessForStudentPortfolio}
              extensionTagSize={extensionTagSize}
              {...(isWorkBook && isTablet ? { backgroundSize: "contain" } : {})}
              {...(isTablet
                ? { itemStyles: { backgroundPosition: "center" } }
                : {})}
            />
          )}

          {/* Tags for journal post / Tagged outcomes for porject */}
          {isProjectPostCard ? (
            <TaggedElementPYP
              elementPYP={_.get(post, "elementPYP", BLANK_ARRAY)}
              otherTags={otherTags}
              hideElementPYP={hideElementPYP}
              toggleTagModal={toggleTagModal}
              t={t}
              goToRelativeRoute={goToRelativeRoute}
              maxOtherTagsToShow={maxOtherTagsToShow}
              maxWidthForTag={maxWidthForTag}
              customTagContainerStyle={customTagContainerStyle}
              isDSV2={isDSV2}
            />
          ) : isPortfolioParityEnabled() ? null : (
            // <TaggedFoldersV2
            //   folders={tags}
            //   tagSize={"small"}
            //   containerStyle={{ //DQC change to remove tagged folders from feed
            //     marginTop:
            //       _.get(post, "attachments.length", 0) > 0 ? "10px" : "16px",
            //   }}
            //   singleTagContainerStyle={{ padding: "4px 8px 4px 0" }}
            // />
            <TaggedFolders
              folders={tags}
              tagSize={"small"}
              containerStyle={tagFolderContainerStyle}
              singleTagContainerStyle={singleTagContainerStyle}
            />
          )}
        </div>
        {isPortfolioParityEnabled() && !isProjectPostCard ? (
          <div className={cardFooterClass}>
            <div className={classes.cardFooterV2}>
              <div className={classes.footerButtonLeftContainer}>
                {!(
                  (_.get(post, "state", "") == "DRAFT" &&
                    userType == "student") ||
                  (_.get(postFilters, "state") === "IN_APPROVAL_STAFF" &&
                    isPortfolioReviewSetupEnabled() &&
                    !isUserAllowedToPublishPost)
                ) && hasManageAccessForStudentPortfolio ? (
                  <FooterButtons
                    staffEditAccess={staffEditAccess}
                    userType={userType}
                    id={_.get(post, "id")}
                    showLikeButton={_.isNil(hideLike) ? true : !hideLike}
                    likes={
                      selectedActivityStudentIndex !== -1
                        ? _.size(filteredStudentActivities) > 1 &&
                          !isSidePaneContent
                          ? null
                          : _.get(
                              filteredStudentActivities,
                              [selectedActivityStudentIndex, "item", "likes"],
                              {}
                            )
                        : _.get(post, "likes", BLANK_OBJECT)
                    }
                    showCommentButton={
                      _.isNil(hideComments) ? true : !hideComments
                    }
                    comments={
                      selectedActivityStudentIndex !== -1
                        ? _.get(
                            filteredStudentActivities,
                            [selectedActivityStudentIndex, "item", "comments"],
                            BLANK_OBJECT
                          )
                        : _.get(post, "comments", BLANK_OBJECT)
                    }
                    seenCount={_.get(post, "seen.totalCount", 0)}
                    state={_.get(post, "state")}
                    userId={currentUserId}
                    isCommentOpen={isCommentOpen}
                    onPostActionClick={onPostActionClick}
                    canEditOrDelete={canEditOrDelete}
                    createdByType={_.get(postCreator, "type")}
                    t={t}
                    createdByName={_.get(postCreator, "firstName")}
                    isArchivedClass={isArchivedClass}
                    isAddLEToJournal={_.isEqual(
                      _.get(assesmentData, "itemType", ""),
                      "STUDENT_ASSIGNMENT"
                    )}
                    isSidePaneContent={isSidePaneContent}
                    showTranslationButton={
                      hasTranslationPermission() &&
                      _.get(post, "titleTranslationItem.showTranslate", false)
                    }
                    showTranslatedText={showTranslatedText}
                    toggleTranslatedText={toggleTranslatedText}
                    isViewFromPostPage={isViewFromPostPage}
                    showLikeCount={true}
                    showCommentCount={true}
                    countTextDisplayed={countTextDisplayed}
                    isPostTypeActivity={!_.isEmpty(filteredStudentActivities)}
                    showDesignV2={true}
                    isUserAllowedToPublishPost={isUserAllowedToPublishPost}
                    isPostCtaDisabled={
                      isPostCtaDisabled ||
                      (isPortfolioReviewSetupEnabled() && !canUserEditPost)
                    }
                    canUserEditPost={canUserEditPost}
                    setTitleText={setTitleText}
                    hasManageAccessForStudentPortfolio={
                      hasManageAccessForStudentPortfolio
                    }
                  />
                ) : null}
                {_.get(post, "state", "") == "DRAFT" &&
                  userType == "student" &&
                  (isApprovalRequiredForStudentPosts ? (
                    <Button
                      variant="progressive"
                      size="large"
                      onClick={() =>
                        onPostActionClick({
                          id: _.get(post, "id"),
                          action: "IN_APPROVAL",
                        })
                      }
                      disabled={isArchivedClass || isStudentArchived}
                      testId="journal-feed-postcard-sendforapproval"
                    >
                      <span style={{ marginRight: "4px", marginTop: "4px" }}>
                        <PublishOutlined variant="on" />
                      </span>
                      <div className={classes.approveText}>
                        {t("journal:send_for_approval")}
                      </div>
                    </Button>
                  ) : (
                    <Button
                      variant="progressive"
                      size="large"
                      onClick={() =>
                        onPostActionClick({
                          id: _.get(post, "id"),
                          action: "PUBLISH",
                        })
                      }
                      disabled={isArchivedClass || isStudentArchived}
                      testId="journal-feed-postcard-publish"
                    >
                      <span style={{ marginRight: "4px", marginTop: "4px" }}>
                        <PublishOutlined variant="on" />
                      </span>
                      <div className={classes.approveText}>
                        {t("common:publish")}
                      </div>
                    </Button>
                  ))}
              </div>
              {/* <div className={classes.footerButtonRightContainer}>
                {/* See translation button */}
              {/* {showTranslationButton && (
                  <Button
                    variant={"inline"}
                    onClick={() => setShowTranslation(!showTranslation)}
                  >
                    <span style={{ fontSize: "1.4rem" }}>
                      {t(
                        showTranslation
                          ? "common:see_original"
                          : "common:see_translation"
                      )}
                    </span>
                  </Button>
                )} */}
              {/* </div> */}
            </div>
            {_.get(post, "state", "") == "PUBLISHED" && !isProjectPostCard ? (
              <FooterText
                showLike={true}
                likesCount={_.get(post, "likes.totalCount", 0)}
                viewsCount={_.get(post, "seen.totalCount", 0)}
                likedByName={likedByFooterTextName}
                t={t}
                showViews={userType === "staff"}
                userType={userType}
                toggleLikeModal={toggleLikesModal}
                toggleViewsModal={toggleViewsModal}
                showComment={_.isNil(hideComments) ? true : !hideComments}
                commentsCount={_.get(post, "comments.totalCount", 0)}
                showCommentsPane={e => {
                  onPostActionClick({
                    id: _.get(post, "id"),
                    action: "COMMENT",
                  });
                  if (!isSidePaneContent) {
                    onCardClick(e);
                    return;
                  }
                }}
                showNewDesign={
                  (isJournalRoute || isStudentFeedRoute) &&
                  isPortfolioParityEnabled()
                }
                showNewDesignV2={
                  (isJournalRoute || isStudentFeedRoute) &&
                  isPortfolioFilterRevamp()
                }
              />
            ) : null}
          </div>
        ) : null}
        {!_.isNil(children) ? children : null}
        {canAddComments && (!isPortfolioParityEnabled() || isProjectPostCard) && (
          <div className={classes.cardFooter}>
            {/* comment button */}
            {!isRightPaneCard &&
              !isSidePaneContent &&
              (_.get(post, "state", "") == "PUBLISHED" ||
                isProjectPostCard ||
                alwaysShowComment) && (
                <ConditionalWrapper
                  type="wrapperAsElement"
                  condition={
                    (!showCommentButton && commentsCount == 0) ||
                    !props?.canPublishComment
                  }
                  wrapper={
                    <Tooltip
                      tooltip={t("common:comments_are_off")}
                      placement={"top"}
                    />
                  }
                >
                  <Button
                    icon={<CommentCircleRightOutlined />}
                    _legacy_variant="inline"
                    _legacy_size="medium"
                    size="large"
                    type="inline"
                    variant="neutral"
                    onClick={() => {
                      setShowCommentBox(true);
                      setTimeout(() => {
                        if (commentBoxRef && commentBoxRef?.current) {
                          commentBoxRef?.current?.focus();
                        }
                      });
                    }}
                    disabled={!showCommentButton}
                    className={isDSV2 ? classes.commentButton : null}
                    testId="journal-feed-postcard-commentbutton"
                  >
                    {t("common:comment")}
                  </Button>
                </ConditionalWrapper>
              )}

            {_.get(post, "state", "") == "DRAFT" &&
              !isSidePaneContent &&
              userType != "parent" && (
                <Button
                  variant="progressive"
                  size="medium"
                  onClick={() =>
                    onPostActionClick({
                      id: _.get(post, "id"),
                      action: "PUBLISH",
                    })
                  }
                  disabled={isArchivedClass}
                >
                  <span style={{ marginRight: "4px", marginTop: "4px" }}>
                    <PublishOutlined variant="on" />
                  </span>
                  <div className={classes.approveText}>
                    {t("common:publish")}
                  </div>
                </Button>
              )}

            {/* See translation button */}
            {showTranslationButton && (
              <Button
                _legacy_variant={"inline"}
                variant="neutral"
                type="inline"
                onClick={() => setShowTranslation(!showTranslation)}
                size={isProjectPostCard ? "x-small" : "medium"}
              >
                <span
                  style={{ fontSize: isProjectPostCard ? "1.2rem" : "1.4rem" }}
                >
                  {t(
                    showTranslation
                      ? "common:see_original"
                      : "common:see_translation"
                  )}
                </span>
              </Button>
            )}
          </div>
        )}
        {/* Latest comment with view {N} comments button */}
        {isSidePaneContent && isProjectPostCard && commentsCount > 0 ? (
          <div className={classes.separator} />
        ) : null}
        {props?.isCommentEnabled &&
        !isRightPaneCard &&
        (isJournalRoute ||
        isStudentFeedRoute ||
        isPortfolioReviewSetupEnabledAndIsReviewRoute()
          ? isPortfolioParityEnabled()
            ? isPortfolioReviewSetupEnabledAndIsReviewRoute()
              ? _.get(post, "state", "") !== "IN_APPROVAL"
              : isSidePaneContent
            : true
          : true) ? (
          <div
            className={
              isProjectPostCard
                ? classes.commentsContainerV2
                : classes.commentsContainer
            }
          >
            {isSidePaneContent && isProjectPostCard && commentsCount > 0 ? (
              <span
                className={classNames({
                  [classes.commentText]: true,
                  ["text-label-l"]: true,
                })}
              >
                {t("common:comment_plural")}
              </span>
            ) : null}
            <CardCommentsV2
              parentId={_.get(post, "id")}
              parentType={"POST"}
              showCommentBox={showCommentBox && props?.isCommentEnabled}
              canPublishComment={props?.canPublishComment}
              commentBoxRef={commentBoxRef}
              canComment={props?.isCommentEnabled && canAddComments}
              canDelete={canAddComments}
              showViewAllComments={!isSidePaneContent}
              refetchComment={refetchComment}
              setRefetchComment={setRefetchComment}
              showCommentBadge={!showPostBadge && showBadge} // Adding this because if post is unread we don't show comment badges
              commentsFromProps={commentsFromProps}
              isJournal={isJournalRoute || isStudentFeedRoute}
              totalCount={_.get(
                post,
                "latestComments.totalCount",
                _.get(post, "comments.totalCount", 0)
              )}
              cacheVariables={{ first: 1 }}
              postFragment={postFragment}
              showViewCommentButtonText={showViewCommentButtonText}
              showViewCommentButtonAtTop={showViewCommentButtonAtTop}
              unreadCount={unreadCommentsCount}
              hasManageAccessForStudentPortfolio={
                isSidePaneContent
                  ? hasManageAccessForStudentPortfolioFromProps
                  : hasManageAccessForStudentPortfolio
              }
              isProjectPostCard={isProjectPostCard}
            />
          </div>
        ) : null}
        {(showLikesModal || showViewsModal) && (
          <PostSeenLikeModal
            isModalOpen={showLikesModal || showViewsModal}
            closeSeenLikeModal={closeSeenLikeModal}
            postId={_.get(post, "id")}
            showLikes={showLikesModal}
            showViews={showViewsModal}
            t={t}
          />
        )}
        {showPostScheduleModal ? (
          <SchedulePostModal
            onClosePostScheduleModal={onClosePostScheduleModal}
            onConfirmDateChange={onConfirmDateChange}
            t={t}
          />
        ) : null}
        {isSharingModalOpen && (
          <PostSharedWithModal
            isModalOpen={isSharingModalOpen}
            closeSharingModal={() => setSharingModalOpen(false)}
            post={post}
            taggedStudents={getStudents(_.get(post, "students.edges", []))}
            isPrivate={isPrivate}
            isHiddenFromStudents={isHiddenFromStudents}
            t={t}
          />
        )}
      </div>
    );
  }
});

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );
  const translationFilter = getPostTranslationFilter({
    userInfo,
    shouldTranslate: _.get(ownProps, "showTranslation", false),
    handleTranslation: _.get(ownProps, "showTranslationButton", false),
  });
  const userType = userInfo.user_type;
  const isCommentEnabled =
    _.get(ownProps, "canAddComments", true) &&
    _.get(ownProps, "showCommentButton", true) &&
    (userType === "staff" ||
      (_.get(ownProps, "isProjectPostCard") &&
        _.get(ownProps, "showCommentButton")) ||
      _.get(ownProps, "alwaysShowComment") ||
      getSettingValue({
        name:
          userType === "parent"
            ? "enableFamilyCommentCreation"
            : "EnableCommentingOnPostByStudents",
        courseId: _.get(state, "teacher.selected_class.selected_course"),
        organizationId: userInfo.org_id,
        userId: userInfo.id,
        userEntityType: userInfo.userEntityType,
      }));

  const academicYearId = getSelectedAcademicYearId(state);

  const isRemovedCourseForLoggedInUser = _.get(
    getCourseDetailsFromCache({
      id: _.get(state, "teacher.selected_class.selected_course"),
      courseGradeFilters: { academicYearId },
    }),
    "isRemovedCourseForLoggedInUser",
    false
  );

  const isArchivedClass = _.get(
    state,
    "teacher.selected_class.isArchivedClass",
    false
  );
  const canPublishComment =
    !isRemovedCourseForLoggedInUser &&
    !isArchivedClass &&
    _.get(state, "platform.academicYearSelected.isCurrentAcademicYear", true);

  const canDownloadMedia =
    userType != "parent" ||
    _.get(ownProps, "isProjectPostCard") ||
    (userType == "parent" &&
      getSettingValue({
        name: "FamilyCanDownloadMedia",
        currentCurriculumProgramId: getSelectedCurriculumId(state),
      }));
  const showPostLearningGoals =
    userType !== "parent"
      ? true
      : getSettingValue({
          name: "ShowPypElementInFamilyApp",
          currentCurriculumProgramId: getSelectedCurriculumId(state),
        });

  const isApprovalRequiredForStudentPosts =
    getSettingValue({
      name: "EnablePostApprovalRequiredForNewStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: state.login.userInfo.org_id,
      userId: state.login.userInfo.id,
      userEntityType: state.login.userInfo.userEntityType,
    }) || userType != "student";

  const studentId =
    userInfo.childID || ownProps?.portfolioStudentId || userInfo.id;

  const studentActivities = fetchStudentActivitiesMemoized({
    items: _.get(ownProps, "post.items", []),
  });

  const filteredStudentActivities = fetchfilteredStudentActivities(
    studentActivities,
    userType,
    studentId
  );

  const showAllStudentsInFilter =
    (getSettingValue({
      name: "EnableViewEachOtherPostByStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: state.login.userInfo.org_id,
      userId: state.login.userInfo.id,
      userEntityType: state.login.userInfo.userEntityType,
    }) ||
      userType == "staff") &&
    userType != "parent";

  const defaultStudentIdentifierNamePreference = getDefaultStudentIdentifierNamePreference(
    state
  );

  const postFilters = _.get(state, "journal.filters", null);
  // Added global timezone prop to force re render if the timezone changes
  const globalTimezone = getGlobalTimezone();
  return {
    translationFilter,
    userType: userInfo.user_type,
    currentUserId: userInfo.id,
    currentChildId:
      userInfo.user_type === "parent" ? userInfo.childID : undefined,
    organizationId: userInfo?.org_id,
    isCommentEnabled,
    canPublishComment,
    canDownloadMedia,
    currentCurriculumProgramId: getSelectedCurriculumId(state),
    showPostLearningGoals,
    curriculumProgramType: _.get(
      state,
      "platform.currentCurriculumProgram.type"
    ),
    isApprovalRequiredForStudentPosts,
    filteredStudentActivities,
    isRemovedCourseForLoggedInUser,
    defaultStudentNameOrderPreference,
    showAllStudentsInFilter,
    defaultStudentIdentifierNamePreference,
    postFilters,
    globalTimezone,
    studentId,
  };
};

const mapActionCreators = {
  updatePostDate,
  goToRelativeRoute,
  updatePostStatus,
  markPostAsSeenByUser,
  addPostAsSeen,
  downloadFromUrl,
  removeProgressElement,
};

const getQueryParams = props => {
  return props?.ownProps;
};

const SubjectJournalCardWithHOC = compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["common", "journal"] }),
  graphql(getPostTranslationQuery, {
    name: "getPostTranslation",
    skip: ({ showTranslationButton, showTranslation }) =>
      !showTranslation || !showTranslationButton,
    options: ({ post, translationFilter }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: _.get(post, "id"),
        translationFilter,
      },
    }),
    props({ getPostTranslation }) {
      const translatedText = _.get(
        getPostTranslation,
        "node.translatedText.translatedLabel",
        ""
      );
      return {
        translatedText,
      };
    },
  }),
  withQueryParamsBasedInterface({ cb: getQueryParams })
)(SubjectJournalCard);

const SubjectJournalCardWrapper = React.memo(props => {
  const { post = {} } = props;
  const [showTranslation, setShowTranslation] = useState(false);

  return (
    <SubjectJournalCardWithHOC
      {...props}
      showTranslation={showTranslation}
      setShowTranslation={setShowTranslation}
      showTranslationButton={
        hasTranslationPermission() &&
        _.get(post, "titleTranslationItem.showTranslate", false)
      }
    />
  );
});

export default SubjectJournalCardWrapper;
SubjectJournalCard.displayName = "SubjectJournalCard";
SubjectJournalCardWrapper.displayName = "SubjectJournalCardWrapper";
